function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42, _templateObject43, _templateObject44, _templateObject45, _templateObject46, _templateObject47, _templateObject48, _templateObject49, _templateObject50, _templateObject51, _templateObject52, _templateObject53, _templateObject54, _templateObject55, _templateObject56, _templateObject57, _templateObject58, _templateObject59, _templateObject60, _templateObject61, _templateObject62, _templateObject63, _templateObject64, _templateObject65, _templateObject66, _templateObject67, _templateObject68, _templateObject69, _templateObject70, _templateObject71, _templateObject72, _templateObject73, _templateObject74, _templateObject75, _templateObject76, _templateObject77, _templateObject78, _templateObject79, _templateObject80, _templateObject81, _templateObject82, _templateObject83, _templateObject84, _templateObject85, _templateObject86, _templateObject87, _templateObject88, _templateObject89, _templateObject90, _templateObject91, _templateObject92, _templateObject93, _templateObject94, _templateObject95, _templateObject96, _templateObject97, _templateObject98, _templateObject99, _templateObject100, _templateObject101, _templateObject102, _templateObject103, _templateObject104, _templateObject105, _templateObject106, _templateObject107;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import React27, { forwardRef, memo, useRef, useEffect, useState, useLayoutEffect, useMemo, useCallback, useContext } from 'react';
import { css, ClassNames } from '@emotion/react';
import { CookiesProvider, useCookies } from 'react-cookie';
import styled22 from '@emotion/styled';
import { EzIcon, EzButton, EzLayout, EzLink, EzModal, EzPopover } from '@ezcater/recipe';
import { faCartShopping, faBars, faCartXmark, faEnvelope, faChevronDown as faChevronDown$1, faX as faX$1 } from '@fortawesome/pro-light-svg-icons';
import { faLock, faCaretDown, faCartShopping as faCartShopping$1, faBell, faCircleUser, faChevronDown, faChevronUp, faX, faArrowRightFromBracket, faLockOpen as faLockOpen$1 } from '@fortawesome/free-solid-svg-icons';
import { parseISO, format } from 'date-fns';
import { compile } from 'path-to-regexp';
import queryString from 'query-string';
import { useLatest } from 'react-use';
import { faHouse, faBowlHot, faBookmark, faReceipt, faSquarePollVertical, faGift, faPencil, faMegaphone, faCommentPlus, faCog, faLocationDot, faCreditCard, faMoneyCheckDollar, faLockOpen, faBuildingUser, faRightFromBracket, faArrowRightToBracket, faCirclePlus, faXmark, faPotFood, faPoll, faCalendarCheck, faComment, faShareNodes, faGear, faPuzzlePiece } from '@fortawesome/pro-regular-svg-icons';
import { createPortal } from 'react-dom';

// src/components/ConsumerCart/ConsumerCart.tsx

// src/styles/recipeMq.ts
var media = {
  base: "(min-width: 0px)",
  baseToMedium: "(max-width: 767.9375px)",
  baseToLarge: "(max-width: 1060.9375px)",
  baseToXLarge: "(max-width: 1279.9375px)",
  medium: "(min-width: 768px)",
  mediumToLarge: "(min-width: 768px) and (max-width: 1060.9375px)",
  large: "(min-width: 1061px)",
  xlarge: "(min-width: 1280px)"
};
var recipeMq = function recipeMq(size) {
  return "@media ".concat(media[size]);
};
var recipeMq_default = recipeMq;

// src/components/TabletAndDesktopExperience/TabletAndDesktopExperience.tsx
var TabletAndDesktopExperience = styled22.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: none;\n\n  ", " {\n    display: ", ";\n  }\n"])), recipeMq_default("medium"), function (_ref) {
  var _ref$display = _ref.display,
    display = _ref$display === void 0 ? "block" : _ref$display;
  return display;
});
var TabletAndDesktopExperience_default = TabletAndDesktopExperience;
var MobileExperience = styled22.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: ", ";\n\n  ", " {\n    display: none;\n  }\n"])), function (_ref2) {
  var _ref2$display = _ref2.display,
    display = _ref2$display === void 0 ? "block" : _ref2$display;
  return display;
}, recipeMq_default("medium"));
var MobileExperience_default = MobileExperience;
var Wrapper = styled22.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  // remove recipe padding on modal content\n  margin: -24px -16px;\n"])));

// src/components/ConsumerCart/components/Modal.tsx
var Modal = function Modal(_ref3) {
  var isOpen = _ref3.isOpen,
    close = _ref3.close,
    children = _ref3.children;
  return /* @__PURE__ */React27.createElement(EzModal, {
    isOpen: isOpen,
    onDismiss: close,
    headerText: "Draft Carts",
    dismissLabel: "Close"
  }, /* @__PURE__ */React27.createElement(Wrapper, null, children));
};
var Modal_default = Modal;

// src/styles/fonts.ts
var fonts = {
  textXs: "0.75rem",
  textSm: "0.875rem",
  textBase: "1rem",
  textLg: "1.125rem",
  textXl: "1.25rem",
  text2xl: "1.5rem",
  text3xl: "1.875rem",
  text4xl: "2.25rem",
  text5xl: "3rem",
  text6xl: "4rem",
  text8xl: "6rem",
  fontFamilyBase: "Lato, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji','Segoe UI Symbol'",
  fontWeightLight: "300",
  fontWeightBase: "400",
  fontWeightSemiBold: "600",
  fontWeightBold: "700",
  fontWeightExtraBold: "900"
};
var fonts_default = fonts;

// src/components/ConsumerCart/components/CartIcon.styles.tsx
var StyledEzButton = styled22.button(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  background: none;\n  border: none;\n  color: inherit;\n  cursor: pointer;\n  padding: 0;\n  line-height: 1rem;\n"])));
var StyledCartEzIcon = styled22(EzIcon)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: ", ";\n"])), fonts_default.textXl);
var StyledCartSpan = styled22.span(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  padding: 2px;\n  align-items: center;\n  justify-content: center;\n"])));
var StyledCaretSpan = styled22.span(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  margin-left: 8px;\n"])));
var RED_DOT_WIDTH = "7px";
var RedDot = styled22.span(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  display: inline-block;\n  background-color: red;\n  height: 7px;\n  width: ", ";\n  border-radius: 50%;\n  position: relative;\n  bottom: 8px;\n  right: 12px;\n"])), RED_DOT_WIDTH);
var StyledEzIcon = styled22(EzIcon, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== "hasCarts";
  }
})(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: inline-block;\n  position: relative;\n  right: 12px;\n  padding-left: ", ";\n"])), function (_ref4) {
  var hasCarts = _ref4.hasCarts;
  return hasCarts ? 0 : RED_DOT_WIDTH;
});

// src/components/ConsumerCart/components/CartIcon.tsx
var CartIcon = function CartIcon(_ref5) {
  var hasCarts = _ref5.hasCarts,
    onClick = _ref5.onClick,
    buttonRef = _ref5.buttonRef,
    onKeyDown = _ref5.onKeyDown;
  return /* @__PURE__ */React27.createElement(StyledEzButton, {
    ref: buttonRef,
    onClick: onClick,
    onKeyDown: onKeyDown,
    "data-testid": "cart-icon-component"
  }, /* @__PURE__ */React27.createElement(StyledCartSpan, null, /* @__PURE__ */React27.createElement(StyledCartEzIcon, {
    title: "Shopping cart",
    icon: faCartShopping,
    size: "medium"
  }), /* @__PURE__ */React27.createElement(StyledCaretSpan, null, hasCarts && /* @__PURE__ */React27.createElement(RedDot, {
    "data-testid": "red-dot"
  }), /* @__PURE__ */React27.createElement(StyledEzIcon, {
    hasCarts: hasCarts,
    title: "caret down",
    size: "xsmall",
    icon: faCaretDown
  }))));
};
var CartIcon_default = CartIcon;
var StyledEzPopoverContentContainer = styled22.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  border: 1px solid #cccfd5;\n  box-shadow: 0px 2px 10px hsla(0, 0%, 0%, 0.25);\n  background-color: #ffffff;\n  position: relative;\n  top: 8px;\n  right: -5px;\n"])));
var StyledEzPopoverContent = styled22.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  max-height: calc(100vh - 208px);\n  overflow-y: auto;\n  min-width: 250px;\n  position: relative;\n"])));
var StyledPopoverArrow = styled22.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  height: 16px;\n  top: -9px;\n  width: 16px;\n\n  &::before {\n    content: '';\n    transform: translateX(0px) rotate(45deg);\n    transform-origin: center;\n    height: 16px;\n    width: 16px;\n    position: absolute;\n    border-left: 1px solid #cccfd5;\n    border-top: 1px solid #cccfd5;\n    background: #fff;\n  }\n"])));

// src/components/ConsumerCart/components/Popover.tsx
var Popover = function Popover(_ref6) {
  var close = _ref6.close,
    buttonRef = _ref6.buttonRef,
    children = _ref6.children,
    className = _ref6.className;
  return /* @__PURE__ */React27.createElement(EzPopover, {
    className: className,
    "data-testid": "ez-popover",
    placement: "bottom-end",
    targetRef: buttonRef,
    shouldCloseOnBlur: true,
    onClose: close
  }, /* @__PURE__ */React27.createElement(StyledEzPopoverContentContainer, null, /* @__PURE__ */React27.createElement(StyledPopoverArrow, {
    "data-popper-arrow": true
  }), /* @__PURE__ */React27.createElement(StyledEzPopoverContent, null, children)));
};
var Popover_default = Popover;
var CartOrderContainer = styled22.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  border-bottom: solid #cccfd5 1px;\n  padding: 10px;\n\n  &:hover {\n    background: ", ";\n  }\n"])), function (_ref7) {
  var isCurrentOrder = _ref7.isCurrentOrder;
  return isCurrentOrder ? "unset" : "#f5f7f7";
});
var CartOrderDetails = styled22.ul(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  padding: 0;\n  margin: 0;\n  text-align: left;\n"])));
var Title = styled22.span(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: 700;\n  font-size: 14px;\n"])), function (_ref8) {
  var isCurrentOrder = _ref8.isCurrentOrder;
  return isCurrentOrder ? "#565a5c" : "#3a64df";
});
var CatererLocation = styled22.p(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  color: #787878;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 14px;\n  margin: 0;\n"])));
var AccountName = styled22.p(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  color: #787878;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 14px;\n  margin: 0;\n"])));
var OrderUpdatedLast = styled22.p(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  font-size: 12px;\n  color: #787878;\n  margin: 0;\n  line-height: 14px;\n"])));

// src/components/ConsumerCart/components/Order.tsx
function navigate(path) {
  window.location.assign(path);
}
var humanizedOrderDate = function humanizedOrderDate(orderDate) {
  var parsedTime = parseISO(orderDate);
  var formattedTime = format(parsedTime, "MMMM d");
  return "Last updated ".concat(formattedTime);
};
var Order = function Order(_ref9) {
  var currentCatererId = _ref9.currentCatererId,
    currentOrderId = _ref9.currentOrderId,
    onClick = _ref9.onClick,
    order = _ref9.order,
    path = _ref9.path,
    trackLink = _ref9.trackLink,
    accountHierarchyPresent = _ref9.accountHierarchyPresent;
  var isCurrentOrder = currentOrderId === order.id && currentCatererId === order.caterer.id;
  var onClickLink = function onClickLink() {
    if (isCurrentOrder) {
      return;
    }
    trackLink(path, "Clicked on draft order ".concat(order.id));
    onClick(order);
    navigate(path);
  };
  var content = /* @__PURE__ */React27.createElement(Title, {
    isCurrentOrder: isCurrentOrder
  }, order.eventName ? /* @__PURE__ */React27.createElement(React27.Fragment, null, order.eventName) : /* @__PURE__ */React27.createElement(React27.Fragment, null, order.caterer.name, isCurrentOrder && " (current)"));
  return /* @__PURE__ */React27.createElement(CartOrderContainer, {
    isCurrentOrder: isCurrentOrder
  }, /* @__PURE__ */React27.createElement(CartOrderDetails, null, isCurrentOrder ? /* @__PURE__ */React27.createElement("span", null, content) : /* @__PURE__ */React27.createElement("a", {
    href: path,
    onClick: onClickLink,
    "data-testid": "order-link"
  }, content), /* @__PURE__ */React27.createElement(CatererLocation, null, order.eventName && /* @__PURE__ */React27.createElement(React27.Fragment, null, order.caterer.name, ", "), order.caterer.address.city, ", ", order.caterer.address.state), accountHierarchyPresent && /* @__PURE__ */React27.createElement(AccountName, null, order.accountName), order.updatedAt && /* @__PURE__ */React27.createElement(OrderUpdatedLast, null, humanizedOrderDate(order.updatedAt))));
};
var Order_default = Order;
var Container = styled22.div(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 24px;\n\n  ", " {\n    margin-top: 0;\n    padding: 21px;\n  }\n"])), recipeMq_default("medium"));
var LoggedInMessage = function LoggedInMessage(_ref10) {
  var startNewOrderPath = _ref10.startNewOrderPath;
  return /* @__PURE__ */React27.createElement(React27.Fragment, null, /* @__PURE__ */React27.createElement("p", null, "You don't have any draft orders to display."), /* @__PURE__ */React27.createElement(EzLink, null, /* @__PURE__ */React27.createElement("a", {
    href: startNewOrderPath,
    onClick: function onClick() {
      window.location.href = startNewOrderPath;
    }
  }, "Start a new order")));
};
var LoggedOutMessage = function LoggedOutMessage(_ref11) {
  var loginPath = _ref11.loginPath;
  return /* @__PURE__ */React27.createElement(React27.Fragment, null, /* @__PURE__ */React27.createElement("p", null, "You don't currently have any draft orders."), /* @__PURE__ */React27.createElement("p", null, "If you're looking for an order that you", /* @__PURE__ */React27.createElement("br", null), "don't see,", " ", /* @__PURE__ */React27.createElement(EzLink, null, /* @__PURE__ */React27.createElement("a", {
    href: loginPath,
    onClick: function onClick() {
      window.location.href = loginPath;
    }
  }, "click here to log in")), "."));
};
var EmptyState = function EmptyState(_ref12) {
  var startNewOrderPath = _ref12.startNewOrderPath,
    loginPath = _ref12.loginPath,
    isLoggedIn2 = _ref12.isLoggedIn;
  var element = isLoggedIn2 ? /* @__PURE__ */React27.createElement(LoggedInMessage, {
    startNewOrderPath: startNewOrderPath
  }) : /* @__PURE__ */React27.createElement(LoggedOutMessage, {
    loginPath: loginPath
  });
  return /* @__PURE__ */React27.createElement(Container, null, /* @__PURE__ */React27.createElement(EzIcon, {
    title: "Empty shopping cart",
    size: "large",
    icon: faCartXmark
  }), element);
};
var EmptyState_default = EmptyState;
var ConsumerCartMouseContainer = styled22.div(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  padding-bottom: 13px;\n"])));
var Container2 = styled22.div(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-top: 24px;\n  justify-content: center;\n\n  ", " {\n    margin-top: 0;\n    padding: 21px;\n  }\n"])), recipeMq_default("medium"));
var SpinnerSVG = styled22.svg(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n  height: 20px;\n  margin-right: 5px;\n  position: relative;\n  top: 2px;\n  width: 20px;\n"])));
var Message = styled22.div(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n  color: #777;\n"])));
function LoadingState() {
  return /* @__PURE__ */React27.createElement(Container2, null, /* @__PURE__ */React27.createElement("div", null, /* @__PURE__ */React27.createElement(SpinnerSVG, {
    version: "1.1",
    id: "L9",
    xmlns: "http://www.w3.org/2000/svg\u201D xmlns:xlink=\u201Chttp://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "25 25 50 50",
    enableBackground: "new 0 0 0 0",
    xmlSpace: "preserve"
  }, /* @__PURE__ */React27.createElement("path", {
    fill: "#ccc",
    d: "M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
  }, /* @__PURE__ */React27.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    dur: "1s",
    from: "0 50 50",
    to: "360 50 50",
    repeatCount: "indefinite"
  })))), /* @__PURE__ */React27.createElement(Message, null, "Loading"));
}
var LoadingState_default = LoadingState;

// src/styles/colors.ts
var colors = {
  black: "#000",
  white: "#ffffff",
  darkGray: "#323232",
  borderGray: "#e6e9eb",
  gray: "#d9d9d9",
  lightGreen: "#f0faf7",
  ezGreen: "#034a34",
  darkEzGreen: "#1D3C34",
  red: "#ff585d",
  gray100: "#f4f7f8",
  gray200: "#eaeaea",
  gray250: "#ced4d9",
  gray300: "#cccfd5",
  gray400: "#999",
  gray500: "#565a5c",
  gray600: "#32353e",
  blue100: "#f6fbff",
  blue200: "#ebf7ff",
  blue300: "#c1def4",
  blue400: "#b1d5f2",
  blue500: "#77b1e2",
  blue600: "#3e90d6",
  blue700: "#1e70bf",
  blue800: "#007ac9"
};
var colors_default = colors;

// src/components/AppBar/components/CartButton/CartButton.styles.tsx
var StyledButton = styled22(EzButton)(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n  height: 42px;\n  width: 92px;\n  margin-top: 13px;\n  box-shadow: none;\n\n  ", " {\n    height: 36px;\n    width: 40px;\n    padding-left: 8px;\n    margin-top: 0;\n  }\n"])), recipeMq_default("baseToMedium"));
var StyledEmptyCartButton = styled22(StyledButton)(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-color: ", ";\n  color: ", ";\n\n  &:hover,\n  &:active,\n  &:focus {\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n  }\n"])), colors_default.lightGreen, colors_default.lightGreen, colors_default.ezGreen, colors_default.lightGreen, colors_default.lightGreen, colors_default.ezGreen);
var StyledCartButton = styled22(StyledButton)(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-color: ", ";\n  color: ", ";\n\n  &:hover,\n  &:active,\n  &:focus {\n    background-color: ", ";\n    border-color: ", ";\n  }\n"])), colors_default.ezGreen, colors_default.ezGreen, colors_default.lightGreen, colors_default.darkEzGreen, colors_default.darkEzGreen);
var StyledCartText = styled22.p(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n  display: inline;\n  padding-right: 5px;\n"])));
var RedDot2 = styled22.span(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n  display: inline-block;\n  background-color: ", ";\n  height: 15px;\n  width: 15px;\n  border-radius: 50%;\n  position: relative;\n  bottom: 19px;\n  right: -12px;\n  border: 2px solid ", ";\n\n  ", " {\n    right: -5px;\n  }\n"])), colors_default.red, colors_default.white, recipeMq_default("baseToMedium"));

// src/components/AppBar/components/CartButton/CartButton.tsx
var StyledEzIcon2 = styled22(EzIcon)(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n  font-size: ", ";\n"])), fonts_default.textXl);
var CartButton = function CartButton(_ref13) {
  var buttonRef = _ref13.buttonRef,
    hasCarts = _ref13.hasCarts,
    onClick = _ref13.onClick,
    menuPageClickHandler = _ref13.menuPageClickHandler,
    cartHasItems = _ref13.cartHasItems;
  var populatedCart = hasCarts || cartHasItems;
  var Button = populatedCart ? StyledCartButton : StyledEmptyCartButton;
  var mobileClickHandler = menuPageClickHandler || onClick;
  return /* @__PURE__ */React27.createElement(React27.Fragment, null, /* @__PURE__ */React27.createElement(TabletAndDesktopExperience_default, null, /* @__PURE__ */React27.createElement(Button, {
    legacy: true,
    use: "primary",
    ref: buttonRef,
    "data-testid": "cart-button-component"
  }, /* @__PURE__ */React27.createElement(StyledCartText, null, "Cart"), /* @__PURE__ */React27.createElement(StyledEzIcon2, {
    icon: faCartShopping$1
  }), hasCarts && /* @__PURE__ */React27.createElement(RedDot2, {
    "data-testid": "red-dot"
  }))), /* @__PURE__ */React27.createElement(MobileExperience_default, null, /* @__PURE__ */React27.createElement(Button, {
    legacy: true,
    use: "primary",
    "data-testid": "cart-button-component",
    onClick: mobileClickHandler
  }, /* @__PURE__ */React27.createElement(StyledEzIcon2, {
    icon: faCartShopping$1
  }), populatedCart && /* @__PURE__ */React27.createElement(RedDot2, {
    "data-testid": "red-dot"
  }))));
};
var CartButton_default = CartButton;

// src/components/ConsumerCart/ConsumerCart.tsx
var catchAllClicks = function catchAllClicks(e) {
  e.stopPropagation();
  e.preventDefault();
};
var ConsumerCart = function ConsumerCart(_ref14) {
  var compileOrderPath = _ref14.compileOrderPath,
    startNewOrderPath = _ref14.startNewOrderPath,
    onOpen = _ref14.onOpen,
    onClickOrder = _ref14.onClickOrder,
    currentOrderId = _ref14.currentOrderId,
    currentCatererId = _ref14.currentCatererId,
    containerClassNames = _ref14.className,
    popoverClassNames = _ref14.popoverClassNames,
    loginPath = _ref14.loginPath,
    _ref14$useNewCart = _ref14.useNewCart,
    useNewCart = _ref14$useNewCart === void 0 ? false : _ref14$useNewCart,
    menuPageClickHandler = _ref14.menuPageClickHandler,
    cartHasItems = _ref14.cartHasItems,
    _ref14$isLoggedIn = _ref14.isLoggedIn,
    isLoggedIn2 = _ref14$isLoggedIn === void 0 ? false : _ref14$isLoggedIn,
    _ref14$orders = _ref14.orders,
    orders = _ref14$orders === void 0 ? [] : _ref14$orders,
    _ref14$loading = _ref14.loading,
    loading = _ref14$loading === void 0 ? false : _ref14$loading,
    trackLink = _ref14.trackLink,
    _ref14$accountHierarc = _ref14.accountHierarchyPresent,
    accountHierarchyPresent = _ref14$accountHierarc === void 0 ? false : _ref14$accountHierarc;
  var onOpenRef = useRef(onOpen);
  onOpenRef.current = onOpen;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isModalOpen = _useState2[0],
    setIsModalOpen = _useState2[1];
  var _React27$useState = React27.useState(false),
    _React27$useState2 = _slicedToArray(_React27$useState, 2),
    isPopoverVisible = _React27$useState2[0],
    setIsPopoverVisible = _React27$useState2[1];
  var ref = React27.useRef(null);
  var hasCarts = orders.length > 0;
  var openModal = function openModal() {
    return setIsModalOpen(true);
  };
  var closeModal = function closeModal() {
    return setIsModalOpen(false);
  };
  useEffect(function () {
    var _a;
    if (isModalOpen || isPopoverVisible) {
      (_a = onOpenRef == null ? void 0 : onOpenRef.current) == null ? void 0 : _a.call(onOpenRef);
    }
  }, [isModalOpen, isPopoverVisible]);
  var orderComponents = orders.map(function (order) {
    return /* @__PURE__ */React27.createElement(Order_default, {
      currentOrderId: currentOrderId,
      currentCatererId: currentCatererId,
      key: order.id,
      order: order,
      path: compileOrderPath({
        orderId: order.id,
        catererUrlId: order.caterer.urlId
      }),
      trackLink: trackLink,
      onClick: onClickOrder,
      accountHierarchyPresent: accountHierarchyPresent
    });
  });
  var content;
  if (loading && !hasCarts) {
    content = /* @__PURE__ */React27.createElement(LoadingState_default, null);
  } else if (hasCarts) {
    content = orderComponents;
  } else {
    content = /* @__PURE__ */React27.createElement(EmptyState_default, {
      startNewOrderPath: startNewOrderPath,
      loginPath: loginPath,
      isLoggedIn: isLoggedIn2
    });
  }
  return /* @__PURE__ */React27.createElement(CookiesProvider, null, /* @__PURE__ */React27.createElement("div", {
    className: containerClassNames,
    "data-testid": "cart-container",
    onClick: catchAllClicks
  }, /* @__PURE__ */React27.createElement(TabletAndDesktopExperience_default, null, /* @__PURE__ */React27.createElement(ConsumerCartMouseContainer, {
    onMouseEnter: function onMouseEnter() {
      return setIsPopoverVisible(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsPopoverVisible(false);
    }
  }, useNewCart ? /* @__PURE__ */React27.createElement(CartButton_default, {
    buttonRef: ref,
    hasCarts: hasCarts
  }) : /* @__PURE__ */React27.createElement(CartIcon_default, {
    onKeyDown: function onKeyDown(e) {
      return e.key === "Escape" && setIsPopoverVisible(false);
    },
    buttonRef: ref,
    hasCarts: hasCarts
  }), isPopoverVisible && /* @__PURE__ */React27.createElement(ClassNames, null, function (_ref15) {
    var cssHelper = _ref15.css;
    return /* @__PURE__ */React27.createElement(Popover_default, {
      className: cssHelper(popoverClassNames),
      close: function close() {
        return setIsPopoverVisible(false);
      },
      buttonRef: ref
    }, content);
  }))), /* @__PURE__ */React27.createElement(MobileExperience_default, null, useNewCart ? /* @__PURE__ */React27.createElement(CartButton_default, {
    hasCarts: hasCarts,
    onClick: openModal,
    menuPageClickHandler: menuPageClickHandler,
    cartHasItems: cartHasItems
  }) : /* @__PURE__ */React27.createElement(CartIcon_default, {
    hasCarts: hasCarts,
    onClick: openModal
  }), /* @__PURE__ */React27.createElement(Modal_default, {
    isOpen: isModalOpen,
    close: closeModal
  }, content))));
};
var ConsumerCart_default = ConsumerCart;
var TOOLBAR_HEIGHT = "80px";
var HAMBURGER_BUTTON_PADDING = "8px";
var Toolbar = styled22(EzLayout)(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  font-size: 16px;\n  height: ", ";\n  min-height: ", ";\n  display: flex;\n  align-items: center;\n  padding: 25px;\n  color: ", ";\n  border-bottom: 1px solid ", ";\n"])), colors_default.white, TOOLBAR_HEIGHT, TOOLBAR_HEIGHT, colors_default.darkGray, colors_default.borderGray);
var MobileToolbar = styled22(Toolbar)(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n  padding-left: min(calc(25px - ", "), 3%);\n"])), HAMBURGER_BUTTON_PADDING);
var StyledEzIcon3 = styled22(EzIcon)(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n  color: ", " !important;\n  font-size: ", ";\n"])), colors_default.darkGray, fonts_default.textBase);
var StyledEzButton2 = styled22(EzButton)(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["\n  color: ", " !important;\n  font-weight: normal !important;\n  padding: 11px 8px !important;\n  border-radius: 4px !important;\n  margin-right: 4px !important;\n  text-decoration: none;\n\n  &:hover,\n  &:active,\n  &:focus {\n    background-color: ", " !important;\n    border-color: ", " !important;\n    color: ", ";\n    font-weight: normal;\n    text-decoration: none !important;\n  }\n"])), colors_default.darkGray, colors_default.lightGreen, colors_default.lightGreen, colors_default.darkGray);
var StyledEzLink = styled22(EzLink)(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["\n  padding: 11px 8px;\n  border-radius: 4px;\n  margin-right: 4px;\n  color: ", ";\n  font-weight: normal;\n\n  &:hover,\n  &:active,\n  &:focus {\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n    font-weight: normal;\n  }\n\n  @media (max-width: 320px) {\n    display: none;\n  }\n"])), colors_default.darkGray, colors_default.lightGreen, colors_default.lightGreen, colors_default.darkGray);
var AdminLink = styled22(EzLink)(_templateObject35 || (_templateObject35 = _taggedTemplateLiteral(["\n  color: ", ";\n  border: 1px solid ", ";\n  border-radius: 4px;\n  margin-right: 48px;\n  padding: 8px;\n  font-family: Lato;\n  font-weight: 400;\n\n  &:hover,\n  &:active,\n  &:focus {\n    color: ", ";\n    border: 1px solid ", ";\n    text-decoration: none;\n  }\n"])), colors_default.ezGreen, colors_default.ezGreen, colors_default.ezGreen, colors_default.ezGreen);
var VerticalDivider = styled22.div(_templateObject36 || (_templateObject36 = _taggedTemplateLiteral(["\n  width: 1px;\n  height: 30px;\n  margin-left: 6px;\n  margin-right: 10px;\n\n  background: ", ";\n"])), colors_default.gray);
var ChannelPartnerLogo = styled22.img(_templateObject37 || (_templateObject37 = _taggedTemplateLiteral(["\n  width: 120px;\n  height: 30px;\n"])));

// src/paths.ts
var MY_ACCOUNT_ROOT = "/my-account";
var ORDERS_ROOT = "".concat(MY_ACCOUNT_ROOT, "/orders");
var ADDRESSES_ROOT = "".concat(MY_ACCOUNT_ROOT, "/addresses");
var ADMIN_PATH = "/admin";
var ADMIN_ORDER_PATH = "/admin/orders/:cartId";
var ROOT_PATH = "/";
var SIGN_IN_PATH = "/sign_in";
var SIGN_UP_PATH = "/create_account";
var SIGN_OUT_PATH = "/sign_ins";
var SAVED_RESTAURANTS_PATH = "".concat(MY_ACCOUNT_ROOT, "/saved-caterers");
var START_NEW_ORDER_PATH = "/start-new-order";
var WELCOME_BACK_PATH = "/welcome-back".concat(START_NEW_ORDER_PATH);
var ADDRESSES_PATH = ADDRESSES_ROOT;
var ORDERS_PATH = ORDERS_ROOT;
var ORDER_VIEW_PATH = "".concat(MY_ACCOUNT_ROOT, "/orders/:orderId");
var PAYMENT_METHODS_PATH = "".concat(MY_ACCOUNT_ROOT, "/payment-methods");
var REFER_A_FRIEND_PATH = "/refer-a-friend";
var REVIEWS_PATH = "".concat(MY_ACCOUNT_ROOT, "/reviews");
var SUGGEST_RESTAURANT_PATH = "".concat(MY_ACCOUNT_ROOT, "/suggest-caterer");
var EZ_REWARDS_PATH = "/ez-rewards";
var RECEIPTS_PATH = "".concat(MY_ACCOUNT_ROOT, "/receipts");
var GROUP_POLLS_PATH = "".concat(MY_ACCOUNT_ROOT, "/group-polls");
var MY_PROFILE_PATH = "".concat(MY_ACCOUNT_ROOT, "/personal-information");
var YOUR_ORDERS_PATH = "".concat(MY_ACCOUNT_ROOT, "/orders");
var EXPENSE_REPORTING_PATH = "/expense-reporting";

// src/components/AppBar/components/Logo/Logo2023.tsx
var LogoContainer = styled22.div(_templateObject38 || (_templateObject38 = _taggedTemplateLiteral(["\n  padding-top: 5px;\n  margin-right: 10px;\n  display: flex;\n  align-items: center;\n"])));
var Logo2023 = function Logo2023(_ref16) {
  var _ref16$href = _ref16.href,
    href = _ref16$href === void 0 ? ROOT_PATH : _ref16$href,
    trackLink = _ref16.trackLink;
  return /* @__PURE__ */React27.createElement(LogoContainer, null, /* @__PURE__ */React27.createElement("a", {
    href: href,
    onClick: function onClick() {
      return trackLink(href, "logo");
    }
  }, /* @__PURE__ */React27.createElement("svg", {
    width: "120",
    height: "30",
    viewBox: "0 0 360 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "ezcater-logo-2023",
    "aria-label": "ezCater Homepage"
  }, /* @__PURE__ */React27.createElement("path", {
    d: "M176.72 57.1499C175.41 58.5199 174 59.5999 172.51 60.3499C170.85 61.1799 168.79 61.5999 166.39 61.5999C164.18 61.5999 162.17 61.1999 160.42 60.4199C158.67 59.6399 157.15 58.5499 155.9 57.1799C154.65 55.7999 153.66 54.1599 152.96 52.2899C152.26 50.4099 151.9 48.3899 151.9 46.2799C151.9 44.1699 152.21 42.0599 152.82 40.0899C153.42 38.1499 154.32 36.4099 155.49 34.9299C156.63 33.4799 158.08 32.3199 159.78 31.4899C161.48 30.6599 163.52 30.2299 165.86 30.2299C168.2 30.2299 170.34 30.6499 172.04 31.4899C173.62 32.2599 175.16 33.4099 176.64 34.8599C176.94 33.9599 177.27 33.0799 177.64 32.2099C179.01 29.0499 180.79 26.1599 182.95 23.5699C181.21 22.2799 179.31 21.2199 177.26 20.4199C173.78 19.0699 170.09 18.3799 166.29 18.3799C162.2 18.3799 158.44 19.0699 155.09 20.4299C151.73 21.7999 148.81 23.7299 146.41 26.1699C144.01 28.6099 142.12 31.5699 140.79 34.9599C139.47 38.3399 138.8 42.0799 138.8 46.0899C138.8 50.0999 139.47 53.8299 140.79 57.1699C142.12 60.5299 144.04 63.4599 146.48 65.8599C148.92 68.2599 151.85 70.1499 155.21 71.4799C158.55 72.7999 162.28 73.4699 166.29 73.4699C170.08 73.4699 173.72 72.8399 177.13 71.5999C179.25 70.8199 181.22 69.7299 183.03 68.3299C180.83 65.7299 179.02 62.7899 177.64 59.5499C177.3 58.7599 177.01 57.9599 176.73 57.1499H176.72Z",
    fill: "#00B373"
  }), /* @__PURE__ */React27.createElement("path", {
    d: "M322.74 45.9699C322.74 42.6399 322.28 39.3099 321.37 36.0799C320.44 32.7899 318.92 29.7899 316.86 27.1699C314.77 24.5299 312.08 22.3599 308.86 20.7299C305.62 19.0899 301.64 18.2599 297.02 18.2599C293.14 18.2599 289.49 18.9699 286.17 20.3699C282.85 21.7699 279.95 23.7399 277.55 26.2099C275.15 28.6899 273.24 31.6299 271.89 34.9699C270.53 38.3099 269.84 41.9799 269.84 45.8599C269.84 49.7399 270.47 53.3799 271.72 56.7099C272.97 60.0599 274.78 63.0199 277.11 65.4899C279.45 67.9699 282.33 69.9499 285.7 71.3499C289.06 72.7499 292.83 73.4599 296.92 73.4599C306.8 73.4599 314.6 69.8399 320.12 62.7099L321.06 61.4899L311.53 54.2099L310.59 55.3699C308.89 57.4599 307 59.1699 305 60.4299C303.09 61.6299 300.8 62.2399 298.17 62.2399C296.19 62.2399 294.24 61.9199 292.39 61.2799C290.55 60.6399 288.91 59.7499 287.53 58.6099C286.16 57.4899 285.04 56.1199 284.2 54.5299C283.61 53.4099 283.22 52.1799 283.06 50.8699H322.74V45.9799V45.9699ZM283.08 40.2499C283.23 39.2799 283.52 38.2999 283.94 37.3099C284.6 35.7799 285.54 34.3599 286.73 33.0999C287.91 31.8599 289.39 30.8299 291.12 30.0399C292.83 29.2599 294.75 28.8699 296.82 28.8699C298.89 28.8699 300.88 29.1999 302.47 29.8599C304.03 30.4999 305.34 31.3899 306.37 32.5099C307.4 33.6299 308.19 34.9799 308.72 36.5199C309.11 37.6699 309.38 38.9099 309.52 40.2499H283.09H283.08Z",
    fill: "#00B373"
  }), /* @__PURE__ */React27.createElement("path", {
    d: "M359.02 19.3099C355.11 17.9999 351.9 18.0199 348.54 19.0099C346.89 19.4999 345.34 20.1699 343.95 20.9899C342.55 21.8199 341.26 22.8399 340.12 24.0199C340.09 24.0499 340.07 24.0799 340.04 24.0999V19.5199H327.55V72.2099H340.04V45.7599C340.04 40.7499 341.13 37.0499 343.28 34.7799C345.44 32.4999 348.53 31.3899 352.74 31.3899C352.74 31.3899 355.66 31.3599 359.02 32.5699V19.3099Z",
    fill: "#00B373"
  }), /* @__PURE__ */React27.createElement("path", {
    d: "M262.4 19.5199V6.68994H249.9V19.5199H243.11V31.2099H249.9V72.1899H262.4V31.2099H269.19V19.5199H262.4Z",
    fill: "#00B373"
  }), /* @__PURE__ */React27.createElement("path", {
    d: "M224.87 19.5199V22.3999C223.65 21.6499 222.37 20.9899 221.04 20.4299C217.66 18.9999 213.97 18.2699 210.08 18.2699C206.19 18.2699 202.5 18.9999 199.12 20.4299C195.74 21.8599 192.76 23.8499 190.26 26.3599C187.76 28.8599 185.77 31.7999 184.34 35.1099C182.9 38.4299 182.17 42.0599 182.17 45.8699C182.17 49.6799 182.9 53.3199 184.34 56.6799C185.78 60.0299 187.77 62.9699 190.27 65.4299C192.77 67.8999 195.75 69.8699 199.12 71.2999C202.51 72.7399 206.19 73.4699 210.08 73.4699C213.97 73.4699 217.65 72.7399 221.04 71.3099C222.37 70.7499 223.66 70.0899 224.88 69.3499V72.2199H237.37V19.5199H224.88H224.87ZM224.87 45.8599C224.87 48.1799 224.51 50.3499 223.81 52.2999C223.12 54.2199 222.13 55.8799 220.89 57.2199C219.64 58.5599 218.09 59.6299 216.27 60.4199C214.45 61.1999 212.36 61.5999 210.07 61.5999C207.78 61.5999 205.69 61.1999 203.87 60.4199C202.05 59.6399 200.5 58.5599 199.26 57.2199C198.01 55.8799 197.03 54.2299 196.34 52.2999C195.64 50.3599 195.28 48.1899 195.28 45.8599C195.28 43.5299 195.64 41.3599 196.34 39.4199C197.03 37.4999 198.01 35.8499 199.26 34.4999C200.5 33.1599 202.05 32.0899 203.87 31.3099C205.69 30.5199 207.78 30.1299 210.07 30.1299C212.36 30.1299 214.44 30.5299 216.27 31.3099C218.09 32.0899 219.64 33.1699 220.88 34.4999C222.13 35.8399 223.11 37.4999 223.8 39.4199C224.5 41.3699 224.86 43.5399 224.86 45.8599H224.87Z",
    fill: "#00B373"
  }), /* @__PURE__ */React27.createElement("path", {
    d: "M133.42 90.02H1.26001V1.26001H133.42V90.02ZM11.8 79.36H122.75V11.94H11.81V79.36H11.8Z",
    fill: "#00B373"
  }), /* @__PURE__ */React27.createElement("path", {
    d: "M89.26 61.18L115.95 30.05V19.52H73.94V30.81H99.49L73 61.84V72.47H117.43V61.18H89.26Z",
    fill: "#00B373"
  }), /* @__PURE__ */React27.createElement("path", {
    d: "M70.3 46.1C70.3 42.75 69.84 39.4 68.93 36.16C68 32.86 66.48 29.85 64.4 27.21C62.31 24.55 59.6 22.38 56.36 20.74C53.1 19.1 49.1 18.26 44.46 18.26C40.55 18.26 36.88 18.97 33.55 20.38C30.22 21.79 27.3 23.76 24.89 26.25C22.48 28.74 20.57 31.7 19.2 35.05C17.83 38.41 17.14 42.09 17.14 45.99C17.14 49.89 17.77 53.55 19.03 56.89C20.29 60.26 22.11 63.23 24.45 65.72C26.8 68.22 29.7 70.2 33.08 71.61C36.45 73.02 40.25 73.73 44.35 73.73C54.28 73.73 62.12 70.09 67.66 62.92L68.61 61.69L59.03 54.37L58.09 55.53C56.38 57.63 54.49 59.34 52.47 60.62C50.56 61.82 48.25 62.43 45.61 62.43C43.62 62.43 41.66 62.1 39.8 61.46C37.95 60.83 36.31 59.92 34.91 58.78C33.54 57.66 32.41 56.28 31.56 54.68C30.96 53.55 30.58 52.32 30.41 51H70.29V46.09L70.3 46.1ZM30.44 40.35C30.59 39.38 30.88 38.39 31.3 37.4C31.96 35.86 32.9 34.44 34.1 33.17C35.29 31.92 36.77 30.89 38.51 30.1C40.23 29.32 42.15 28.92 44.23 28.92C46.31 28.92 48.31 29.25 49.9 29.91C51.46 30.55 52.79 31.45 53.82 32.57C54.86 33.71 55.65 35.06 56.18 36.6C56.57 37.76 56.84 39.01 56.99 40.35H30.43H30.44Z",
    fill: "#00B373"
  }))));
};
var Logo2023_default = Logo2023;
var MobileAndTabletExperience = styled22.div(_templateObject39 || (_templateObject39 = _taggedTemplateLiteral(["\n  display: none;\n\n  ", " {\n    display: block;\n  }\n"])), recipeMq_default("baseToXLarge"));
var MobileAndTabletExperience_default = MobileAndTabletExperience;
var DesktopExperience = styled22.div(_templateObject40 || (_templateObject40 = _taggedTemplateLiteral(["\n  display: none;\n  ", " {\n    display: block;\n  }\n"])), recipeMq_default("xlarge"));
var DesktopExperience_default = DesktopExperience;
var EZ_RAILS_PREFIX = "http://localhost:3000";
var NEXT_PREFIX = "http://localhost:22030";
var pathMap = {};
var pathPrefix = function pathPrefix(path) {
  if (process.env.NODE_ENV === "production") return "";
  switch (path) {
    case SIGN_IN_PATH:
    case SIGN_UP_PATH:
    case SIGN_OUT_PATH:
    case ADMIN_PATH:
    case ADMIN_ORDER_PATH:
    case ROOT_PATH:
      return EZ_RAILS_PREFIX;
    case SAVED_RESTAURANTS_PATH:
    case START_NEW_ORDER_PATH:
    case WELCOME_BACK_PATH:
    case ADDRESSES_PATH:
    case ORDERS_PATH:
    case ORDER_VIEW_PATH:
    case PAYMENT_METHODS_PATH:
    case REFER_A_FRIEND_PATH:
    case REVIEWS_PATH:
    case SUGGEST_RESTAURANT_PATH:
    case EZ_REWARDS_PATH:
    case YOUR_ORDERS_PATH:
    case MY_PROFILE_PATH:
    case RECEIPTS_PATH:
    case EXPENSE_REPORTING_PATH:
      return NEXT_PREFIX;
    default:
      return "";
  }
};
var compilePath = function compilePath(path) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var queryParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var stringifyOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var stringifiedQueryParams = queryString.stringify(queryParams, stringifyOptions);
  var query = stringifiedQueryParams ? "?".concat(stringifiedQueryParams) : "";
  if (!pathMap[path]) pathMap[path] = compile(path);
  return "".concat(pathPrefix(path)).concat(pathMap[path](params)).concat(query);
};
var compilePath_default = compilePath;
var StyledNavBarItem = styled22.div(_templateObject41 || (_templateObject41 = _taggedTemplateLiteral(["\n  margin-right: 10px;\n"])));
var StyledEzIcon4 = styled22(EzIcon)(_templateObject42 || (_templateObject42 = _taggedTemplateLiteral(["\n  font-size: ", ";\n"])), fonts_default.textBase);
var NavBarItem = forwardRef(function (_ref17, ref) {
  var shouldShow = _ref17.shouldShow,
    icon = _ref17.icon,
    testId = _ref17.testId,
    ariaLabel = _ref17.ariaLabel;
  if (!shouldShow) {
    return null;
  }
  return /* @__PURE__ */React27.createElement(StyledNavBarItem, {
    tabIndex: 0,
    ref: ref,
    "data-testid": testId
  }, /* @__PURE__ */React27.createElement(StyledEzIcon4, {
    icon: icon,
    title: ariaLabel
  }));
});
var NavBarItem_default = NavBarItem;
var NotificationBadge = styled22.span(_templateObject43 || (_templateObject43 = _taggedTemplateLiteral(["\n  display: flex;\n  position: relative;\n  width: 23px;\n  margin-right: -23px;\n  height: 17px;\n  left: -29px;\n  top: -9px;\n\n  background: ", ";\n  border: 2px solid ", ";\n  border-radius: 100px;\n\n  p {\n    margin: auto;\n    font-weight: 800;\n    font-size: 10px;\n    line-height: 12px;\n    color: ", ";\n    align-self: center;\n  }\n\n  ", " {\n    p {\n      color: ", ";\n    }\n\n    left: -19px;\n  }\n"])), colors_default.red, colors_default.white, colors_default.white, recipeMq_default("baseToMedium"), colors_default.white);
var StyledEzButton3 = styled22(EzButton)(_templateObject44 || (_templateObject44 = _taggedTemplateLiteral(["\n  color: ", " !important;\n\n  &:hover,\n  &:active,\n  &:focus {\n    color: ", ";\n  }\n"])), colors_default.darkGray, colors_default.darkGray);
var DirectConnectMouseContainer = styled22.div(_templateObject45 || (_templateObject45 = _taggedTemplateLiteral(["\n  padding: 12px 0;\n"])));
var useToggleState = function useToggleState(initialValue) {
  var _useState3 = useState(Boolean(initialValue)),
    _useState4 = _slicedToArray(_useState3, 2),
    isOpen = _useState4[0],
    setIsOpen = _useState4[1];
  var on = useCallback(function () {
    return setIsOpen(true);
  }, []);
  var off = useCallback(function () {
    return setIsOpen(false);
  }, []);
  var toggle = useCallback(function () {
    return setIsOpen(function (currentValue) {
      return !currentValue;
    });
  }, []);
  return {
    toggleValue: isOpen,
    on: on,
    off: off,
    toggle: toggle,
    setValue: setIsOpen
  };
};
var useToggleState_default = useToggleState;

// src/styles/corners.ts
var corners = {
  borderRoundedNone: "0",
  borderRoundedSm: "0.125rem",
  borderRounded: "0.25rem",
  borderRoundedMd: "0.375rem",
  borderRoundedLg: "0.5rem",
  borderRoundedXl: "0.75rem",
  borderRounded2xl: "1rem",
  borderRounded3xl: "1.5rem",
  borderRoundedFull: "9999px"
};
var corners_default = corners;

// src/components/AppBar/components/DirectConnectButton/DirectConnectPopover.styles.tsx
var DirectConnectPopper = styled22.div(_templateObject46 || (_templateObject46 = _taggedTemplateLiteral(["\n  position: absolute;\n  background-color: ", ";\n  border-radius: ", ";\n  box-shadow: 0 2px 20px 0 rgba(153, 153, 153, 0.35);\n  overflow: auto;\n  top: 100%;\n  width: 350px;\n  right: -10px;\n  z-index: 10000 !important;\n  list-style: none;\n\n  ", " {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    min-height: 100vh;\n    box-shadow: none;\n    border-radius: 0;\n  }\n"])), colors_default.white, corners_default.borderRounded, recipeMq_default("baseToMedium"));
var DirectConnectPopperMessage = styled22(DirectConnectPopper)(_templateObject47 || (_templateObject47 = _taggedTemplateLiteral(["\n  border-radius: ", ";\n  box-shadow: 0 2px 20px 10px rgba(153, 153, 153, 0.35);\n  left: auto;\n  right: -10px;\n  width: 325px;\n\n  ", " {\n    left: 0;\n    right: auto;\n  }\n"])), corners_default.borderRoundedLg, recipeMq_default("baseToMedium"));
var Title2 = styled22.div(_templateObject48 || (_templateObject48 = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  color: ", ";\n  font-size: ", ";\n  padding: 16px;\n  border-bottom: 1px solid ", ";\n"])), fonts_default.fontWeightSemiBold, colors_default.black, fonts_default.textBase, colors_default.gray300);
var EventList = styled22.div(_templateObject49 || (_templateObject49 = _taggedTemplateLiteral(["\n  max-height: calc(100vh - 100px);\n\n  ", " {\n    max-height: 500px;\n    overflow-y: auto;\n  }\n"])), recipeMq_default("medium"));
var BetaMessage = styled22.div(_templateObject50 || (_templateObject50 = _taggedTemplateLiteral(["\n  padding: 20px;\n  text-align: center;\n"])));
var BetaMessageIcon = styled22(EzIcon)(_templateObject51 || (_templateObject51 = _taggedTemplateLiteral(["\n  display: inline-block;\n"])));
var BetaMessageText = styled22.div(_templateObject52 || (_templateObject52 = _taggedTemplateLiteral(["\n  margin: 16px 0;\n  ", " {\n    color: ", ";\n  }\n"])), recipeMq_default("baseToMedium"), colors_default.gray600);
var activeStyles = function activeStyles() {
  return css(_templateObject53 || (_templateObject53 = _taggedTemplateLiteral(["\n  border-left: 5px solid ", ";\n"])), colors_default.blue600);
};
var Card = styled22.div(_templateObject54 || (_templateObject54 = _taggedTemplateLiteral(["\n  display: block;\n  border-bottom: 1px solid ", ";\n  border-left: 5px solid transparent;\n  padding: 12px;\n  font-weight: ", ";\n  color: ", ";\n  ", "\n  &:hover {\n    color: ", ";\n    background-color: ", ";\n  }\n  &:last-of-type {\n    border-bottom: 0;\n  }\n"])), colors_default.gray300, fonts_default.fontWeightBase, colors_default.gray400, function (_ref18) {
  var isUnread = _ref18.isUnread;
  return isUnread && activeStyles();
}, colors_default.black, colors_default.gray100);
var Title3 = styled22.div(_templateObject55 || (_templateObject55 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  margin-bottom: 12px;\n  font-weight: ", ";\n"])), fonts_default.textSm, fonts_default.fontWeightSemiBold);
var Details = styled22.div(_templateObject56 || (_templateObject56 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  display: block;\n  text-overflow: ellipsis;\n  word-wrap: break-word;\n  overflow: hidden;\n  line-height: 18px;\n  max-height: 36px;\n"])), fonts_default.textXs);

// src/components/AppBar/components/DirectConnectButton/DirectConnectNotification.tsx
var DirectConnectNotification = function DirectConnectNotification(_ref19) {
  var brandName = _ref19.brandName,
    changeType = _ref19.changeType,
    isUnread = _ref19.isUnread,
    message = _ref19.message,
    messageType = _ref19.messageType,
    orderUuid = _ref19.orderUuid,
    onCloseCallback = _ref19.onCloseCallback,
    trackLink = _ref19.trackLink;
  var messageTypeText = {
    TimeChangeRequest: "New Delivery Time Requested:",
    Message: "New Message:",
    OrderItemChangeRequest: "".concat(changeType, " Requested:")
  };
  return /* @__PURE__ */React27.createElement(Card, {
    "data-testid": "direct-connect-notification-".concat(orderUuid),
    isUnread: isUnread,
    onClick: function onClick() {
      trackLink(compilePath_default(ORDER_VIEW_PATH, {
        orderId: orderUuid
      }), "Notification for order ".concat(orderUuid, " and brand ").concat(brandName));
      onCloseCallback();
    }
  }, /* @__PURE__ */React27.createElement(EzLink, {
    href: compilePath_default(ORDER_VIEW_PATH, {
      orderId: orderUuid
    })
  }, /* @__PURE__ */React27.createElement(Title3, null, brandName)), /* @__PURE__ */React27.createElement(Details, null, /* @__PURE__ */React27.createElement("strong", null, messageType ? messageTypeText[messageType] : ""), " ", message));
};
var DirectConnectNotification_default = DirectConnectNotification;
var Header = styled22.div(_templateObject57 || (_templateObject57 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n  height: 58px;\n  min-height: 58px;\n  display: flex;\n  justify-content: flex-end;\n"])), colors_default.gray500, colors_default.white);
var toolbarButtonStyle = function toolbarButtonStyle() {
  return css(_templateObject58 || (_templateObject58 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  color: ", ";\n  letter-spacing: 0.34px;\n  padding: 0 16px;\n  background: none;\n  border: none;\n\n  ", " {\n    color: ", ";\n    padding: 0 20px;\n\n    &:hover {\n      color: ", ";\n      background-color: #dbdedf;\n    }\n  }\n"])), colors_default.white, recipeMq_default("medium"), colors_default.gray500, colors_default.gray500);
};
var ToolbarItem = styled22.li(_templateObject59 || (_templateObject59 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: stretch;\n"])));
var ToolbarButton = styled22.button(_templateObject60 || (_templateObject60 = _taggedTemplateLiteral(["\n  ", "\n  cursor: pointer;\n  font-size: inherit;\n  font-family: inherit;\n"])), toolbarButtonStyle);

// src/components/AppBar/components/MobileModalHeader/MobileModalHeader.tsx
var MobileModalHeader = function MobileModalHeader(_ref20) {
  var hideModal = _ref20.hideModal;
  return /* @__PURE__ */React27.createElement(Header, {
    "data-testid": "mobile-modal-header"
  }, /* @__PURE__ */React27.createElement(ToolbarItem, null, /* @__PURE__ */React27.createElement(ToolbarButton, {
    onClick: hideModal
  }, /* @__PURE__ */React27.createElement(EzIcon, {
    icon: faX$1
  }))));
};
var MobileModalHeader_default = MobileModalHeader;
var ScrollLock = function ScrollLock() {
  var documentRef = useRef(null);
  useEffect(function () {
    var _a, _b;
    var doc = (_a = documentRef.current) == null ? void 0 : _a.ownerDocument;
    if (doc) {
      var _doc$body$style = doc.body.style,
        paddingRight = _doc$body$style.paddingRight,
        overflow = _doc$body$style.overflow;
      doc.body.style.paddingRight = "".concat((((_b = doc.defaultView) == null ? void 0 : _b.innerWidth) || 0) - doc.documentElement.clientWidth, "px");
      doc.body.style.overflow = "hidden";
      return function () {
        doc.body.style.overflow = overflow;
        doc.body.style.paddingRight = paddingRight;
      };
    }
    return null;
  }, []);
  return /* @__PURE__ */React27.createElement("span", {
    hidden: true,
    ref: documentRef
  });
};
var ScrollLock_default = memo(ScrollLock);

// src/components/AppBar/components/DirectConnectButton/DirectConnectPopover.tsx
var DirectConnectPopover = function DirectConnectPopover(_ref21) {
  var navItemRef = _ref21.navItemRef,
    notifications = _ref21.notifications,
    onCloseCallback = _ref21.onCloseCallback,
    _ref21$isMobile = _ref21.isMobile,
    isMobile = _ref21$isMobile === void 0 ? false : _ref21$isMobile,
    trackLink = _ref21.trackLink;
  var openFeedbackEmail = function openFeedbackEmail() {
    var path = "mailto:support@ezcater.com";
    trackLink(path, "Give Us Feedback");
    window.location.href = "mailto:support@ezcater.com";
  };
  if (notifications.length > 0) {
    return /* @__PURE__ */React27.createElement(EzPopover, {
      targetRef: navItemRef,
      shouldCloseOnBlur: true,
      onClose: onCloseCallback
    }, isMobile && /* @__PURE__ */React27.createElement(ScrollLock_default, null), /* @__PURE__ */React27.createElement(DirectConnectPopper, null, isMobile && /* @__PURE__ */React27.createElement(MobileModalHeader_default, {
      hideModal: onCloseCallback
    }), /* @__PURE__ */React27.createElement(Title2, null, "Messages from the Caterer"), /* @__PURE__ */React27.createElement(EventList, null, notifications.map(function (_ref22) {
      var id = _ref22.id,
        orderUuid = _ref22.orderUuid,
        isUnread = _ref22.isUnread,
        brandName = _ref22.brandName,
        messageType = _ref22.messageType,
        changeType = _ref22.changeType,
        message = _ref22.message;
      return /* @__PURE__ */React27.createElement(DirectConnectNotification_default, {
        key: id,
        brandName: brandName,
        changeType: changeType,
        isUnread: isUnread,
        message: message,
        messageType: messageType,
        orderUuid: orderUuid,
        onCloseCallback: onCloseCallback,
        trackLink: trackLink
      });
    }))));
  }
  return /* @__PURE__ */React27.createElement(EzPopover, {
    targetRef: navItemRef,
    shouldCloseOnBlur: true,
    onClose: onCloseCallback
  }, isMobile && /* @__PURE__ */React27.createElement(ScrollLock_default, null), /* @__PURE__ */React27.createElement(DirectConnectPopperMessage, null, /* @__PURE__ */React27.createElement(MobileModalHeader_default, {
    hideModal: onCloseCallback
  }), /* @__PURE__ */React27.createElement(BetaMessage, null, /* @__PURE__ */React27.createElement(BetaMessageIcon, {
    icon: faEnvelope,
    size: "large"
  }), /* @__PURE__ */React27.createElement(BetaMessageText, null, "Caterer Messages is a new experience we are trying out. Some things will change about this experience in the future."), /* @__PURE__ */React27.createElement(EzButton, {
    legacy: true,
    use: "primary",
    onClick: openFeedbackEmail
  }, "Give Us Feedback"))));
};
var DirectConnectPopover_default = DirectConnectPopover;
var useMediaQuery = function useMediaQuery(queryInput) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var query = queryInput.replace(/^@media( ?)/m, "");
  var supportMatchMedia = typeof window !== "undefined" && typeof window.matchMedia !== "undefined";
  var _options$defaultMatch = options.defaultMatches,
    defaultMatches = _options$defaultMatch === void 0 ? false : _options$defaultMatch;
  var _useState5 = useState(defaultMatches),
    _useState6 = _slicedToArray(_useState5, 2),
    match = _useState6[0],
    setMatch = _useState6[1];
  useEffect(function () {
    if (!supportMatchMedia) return void 0;
    var active = true;
    var queryList = matchMedia(query);
    var updateMatch = function updateMatch() {
      if (active) setMatch(queryList.matches);
    };
    updateMatch();
    if (queryList == null ? void 0 : queryList.addEventListener) {
      queryList.addEventListener("change", updateMatch);
    } else {
      queryList.addListener(updateMatch);
    }
    return function () {
      active = false;
      if (queryList == null ? void 0 : queryList.removeEventListener) {
        queryList.removeEventListener("change", updateMatch);
      } else {
        queryList.addListener(updateMatch);
      }
    };
  }, [query, supportMatchMedia]);
  return match;
};
var useMediaQuery_default = useMediaQuery;

// src/hooks/useIsMobileCheck.ts
var useIsMobileCheck = function useIsMobileCheck() {
  return useMediaQuery_default("".concat(media.baseToMedium));
};
var useIsMobileCheck_default = useIsMobileCheck;

// src/components/AppBar/components/DirectConnectButton/DirectConnectButton.tsx
var StyledEzIcon5 = styled22(EzIcon)(_templateObject61 || (_templateObject61 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: ", ";\n"])), fonts_default.textBase, colors_default.darkGray);
var DirectConnectButton = function DirectConnectButton(_ref23) {
  var _ref23$notifications = _ref23.notifications,
    notifications = _ref23$notifications === void 0 ? [] : _ref23$notifications,
    trackLink = _ref23.trackLink;
  var _useToggleState_defau = useToggleState_default(),
    showDesktopPopover = _useToggleState_defau.toggleValue,
    show = _useToggleState_defau.on,
    hide = _useToggleState_defau.off;
  var _useToggleState_defau2 = useToggleState_default(),
    showMobileTabletPopover = _useToggleState_defau2.toggleValue,
    hideMobile = _useToggleState_defau2.off,
    toggleMobile = _useToggleState_defau2.toggle;
  var navItemRef = useRef(null);
  var mobileButtonRef = useRef(null);
  var isMobile = useIsMobileCheck_default();
  var unreadNotificationCount = notifications.filter(function (notification) {
    return notification.isUnread;
  }).length;
  return /* @__PURE__ */React27.createElement(React27.Fragment, null, /* @__PURE__ */React27.createElement(DesktopExperience_default, null, /* @__PURE__ */React27.createElement(DirectConnectMouseContainer, {
    onMouseEnter: show,
    onMouseLeave: hide
  }, /* @__PURE__ */React27.createElement(EzLayout, null, /* @__PURE__ */React27.createElement(NavBarItem_default, {
    ref: navItemRef,
    shouldShow: true,
    icon: faBell,
    testId: "direct-connect-nav-bar-item",
    ariaLabel: "Messages: ".concat(unreadNotificationCount, " unread")
  }), unreadNotificationCount > 0 && /* @__PURE__ */React27.createElement(NotificationBadge, null, /* @__PURE__ */React27.createElement("p", null, unreadNotificationCount))), showDesktopPopover && /* @__PURE__ */React27.createElement(DirectConnectPopover_default, {
    navItemRef: navItemRef,
    notifications: notifications,
    onCloseCallback: hide,
    trackLink: trackLink
  }))), /* @__PURE__ */React27.createElement(MobileAndTabletExperience_default, null, /* @__PURE__ */React27.createElement(EzLayout, null, /* @__PURE__ */React27.createElement(StyledEzButton3, {
    legacy: true,
    ref: mobileButtonRef,
    "data-testid": "direct-connect-nav-bar-item",
    use: "tertiary",
    onClick: toggleMobile
  }, /* @__PURE__ */React27.createElement(StyledEzIcon5, {
    icon: faBell
  })), unreadNotificationCount > 0 && /* @__PURE__ */React27.createElement(NotificationBadge, null, /* @__PURE__ */React27.createElement("p", null, unreadNotificationCount))), showMobileTabletPopover && /* @__PURE__ */React27.createElement(DirectConnectPopover_default, {
    navItemRef: isMobile ? navItemRef : mobileButtonRef,
    notifications: notifications,
    onCloseCallback: hideMobile,
    isMobile: isMobile,
    trackLink: trackLink
  })));
};
var DirectConnectButton_default = DirectConnectButton;
styled22(EzLink)(_templateObject62 || (_templateObject62 = _taggedTemplateLiteral(["\n  color: ", ";\n  text-decoration: none;\n  cursor: pointer;\n  height: 20px;\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.1);\n    color: ", ";\n    text-decoration: none;\n  }\n"])), colors_default.gray500, colors_default.gray600);
styled22(EzLayout)(_templateObject63 || (_templateObject63 = _taggedTemplateLiteral(["\n  padding: 0;\n"])));
var NavDropdownMenu = styled22.div(_templateObject64 || (_templateObject64 = _taggedTemplateLiteral(["\n  padding: 0;\n  margin: 10px;\n  background-color: ", ";\n  border: 1px solid ", ";\n  box-shadow: 0 2px 20px 0 rgba(153, 153, 153, 0.35);\n  position: absolute;\n  top: 100%;\n  right: -35px;\n  width: 320px;\n  z-index: 10000 !important;\n  list-style: none;\n\n  &::before {\n    cursor: pointer;\n    z-index: -1;\n    top: -9px;\n    bottom: 100%;\n    right: 16px;\n    content: '';\n    position: absolute;\n    height: 16px;\n    width: 16px;\n    transform: translateX(0px) rotate(45deg);\n    transform-origin: center;\n    border-left: 1px solid ", ";\n    border-top: 1px solid ", ";\n    background-color: ", ";\n  }\n"])), colors_default.white, colors_default.gray300, colors_default.gray300, colors_default.gray300, colors_default.white);
var NavDropdownMenuItem = styled22.li(_templateObject65 || (_templateObject65 = _taggedTemplateLiteral(["\n  display: block;\n  border-bottom: 1px solid ", ";\n\n  ", " {\n    border-bottom: 0;\n  }\n"])), colors_default.gray300, recipeMq_default("large"));
var NavDropdownNavLink = styled22.a(_templateObject66 || (_templateObject66 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  color: ", ";\n  text-decoration: none;\n  cursor: pointer;\n  padding-left: 10px;\n  height: 50px;\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.1);\n    color: ", ";\n  }\n"])), colors_default.gray500, colors_default.gray600);
styled22.div(_templateObject67 || (_templateObject67 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  color: ", ";\n  text-decoration: none;\n  cursor: pointer;\n  padding-left: 10px;\n  height: 50px;\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.1);\n    color: ", ";\n  }\n"])), colors_default.gray500, colors_default.gray600);
var SubText = styled22.em(_templateObject68 || (_templateObject68 = _taggedTemplateLiteral(["\n  margin-left: 15px;\n  font-size: ", ";\n  color: ", ";\n"])), fonts_default.textSm, colors_default.gray400);
var NavDropdownNavButton = styled22.button(_templateObject69 || (_templateObject69 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  color: ", ";\n  text-decoration: none;\n  cursor: pointer;\n  padding-left: 10px;\n  height: 50px;\n  background: none;\n  border: none;\n  font: inherit;\n  outline: inherit;\n  width: 100%;\n  text-align: left;\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.1);\n    color: ", ";\n  }\n"])), colors_default.gray500, colors_default.gray600);
var IconContainer = styled22.span(_templateObject70 || (_templateObject70 = _taggedTemplateLiteral(["\n  padding-right: 7px;\n  vertical-align: middle !important;\n  font-size: 20px;\n\n  > svg {\n    font-size: 20px !important;\n  }\n"])));
var isLoggedIn = function isLoggedIn(_ref24) {
  var consumerAccount = _ref24.consumerAccount;
  return Boolean(consumerAccount);
};
var myAccountLinks = [{
  title: "Start new order",
  mobileTitle: "Start new Order",
  path: START_NEW_ORDER_PATH,
  showTab: isLoggedIn,
  icon: /* @__PURE__ */React27.createElement(EzIcon, {
    icon: faHouse
  })
}, {
  title: "Orders",
  mobileTitle: "My Orders",
  path: ORDERS_PATH,
  showTab: isLoggedIn,
  icon: /* @__PURE__ */React27.createElement(EzIcon, {
    icon: faPotFood
  })
}, {
  title: "Group polls",
  mobileTitle: "Group polls",
  path: GROUP_POLLS_PATH,
  showTab: function showTab(_ref25) {
    var consumerAccount = _ref25.consumerAccount;
    return Boolean(consumerAccount);
  },
  icon: /* @__PURE__ */React27.createElement(EzIcon, {
    icon: faPoll
  })
}, {
  title: "Saved restaurants",
  mobileTitle: "Saved restaurants",
  path: SAVED_RESTAURANTS_PATH,
  showTab: isLoggedIn,
  icon: /* @__PURE__ */React27.createElement(EzIcon, {
    icon: faBookmark
  })
}, {
  title: "Delivery addresses",
  mobileTitle: "Delivery Addresses",
  path: ADDRESSES_PATH,
  showTab: isLoggedIn,
  icon: /* @__PURE__ */React27.createElement(EzIcon, {
    icon: faLocationDot
  })
}, {
  title: "Receipts",
  mobileTitle: "My Receipts",
  path: RECEIPTS_PATH,
  showTab: isLoggedIn,
  icon: /* @__PURE__ */React27.createElement(EzIcon, {
    icon: faCalendarCheck
  })
}, {
  title: "Reviews",
  mobileTitle: "My Reviews",
  subText: function subText(_ref26) {
    var pointsGivenForReview = _ref26.pointsGivenForReview;
    return pointsGivenForReview ? "+".concat(pointsGivenForReview, " points") : "";
  },
  path: REVIEWS_PATH,
  showTab: isLoggedIn,
  icon: /* @__PURE__ */React27.createElement(EzIcon, {
    icon: faPencil
  })
}, {
  title: "Suggest a restaurant",
  mobileTitle: "Suggest a restaurant",
  path: SUGGEST_RESTAURANT_PATH,
  showTab: isLoggedIn,
  icon: /* @__PURE__ */React27.createElement(EzIcon, {
    icon: faComment
  })
}, {
  title: "Refer",
  mobileTitle: "Refer a friend",
  subText: "+25,000 points!",
  path: REFER_A_FRIEND_PATH,
  showTab: isLoggedIn,
  icon: /* @__PURE__ */React27.createElement(EzIcon, {
    icon: faShareNodes
  })
}, {
  title: "Profile",
  mobileTitle: "Account settings",
  path: MY_PROFILE_PATH,
  showTab: isLoggedIn,
  icon: /* @__PURE__ */React27.createElement(EzIcon, {
    icon: faGear
  })
}, {
  title: "ezRewards",
  mobileTitle: "ezRewards",
  path: EZ_REWARDS_PATH,
  showTab: function showTab(_ref27) {
    var consumerAccount = _ref27.consumerAccount;
    return Boolean(consumerAccount == null ? void 0 : consumerAccount.canCollectOwnEzRewards);
  },
  icon: /* @__PURE__ */React27.createElement(EzIcon, {
    icon: faGift
  })
}, {
  title: "Payment methods",
  mobileTitle: "Payment methods",
  path: PAYMENT_METHODS_PATH,
  showTab: isLoggedIn,
  icon: /* @__PURE__ */React27.createElement(EzIcon, {
    icon: faCreditCard
  })
}, {
  title: "Expense reporting",
  mobileTitle: "Expense reporting",
  path: EXPENSE_REPORTING_PATH,
  showTab: function showTab(_ref28) {
    var consumerAccount = _ref28.consumerAccount;
    return Boolean(consumerAccount == null ? void 0 : consumerAccount.canAccessConcur);
  },
  icon: /* @__PURE__ */React27.createElement(EzIcon, {
    icon: faPuzzlePiece
  })
}, {
  title: "Admin",
  mobileTitle: "Admin",
  path: ADMIN_PATH,
  showTab: function showTab(_ref29) {
    var adminAccount = _ref29.adminAccount,
      showMobileItems = _ref29.showMobileItems;
    return Boolean(showMobileItems && adminAccount);
  },
  icon: /* @__PURE__ */React27.createElement(EzIcon, {
    icon: faLockOpen$1
  })
}, {
  title: "Corporate Admin",
  mobileTitle: "Corporate Admin",
  path: function path(_ref30) {
    var corpPortalHost = _ref30.corpPortalHost;
    return corpPortalHost;
  },
  showTab: function showTab(_ref31) {
    var canAccessCorpPortal = _ref31.canAccessCorpPortal,
      showMobileItems = _ref31.showMobileItems;
    return Boolean(showMobileItems && canAccessCorpPortal);
  },
  icon: /* @__PURE__ */React27.createElement(EzIcon, {
    icon: faBuildingUser
  })
}, {
  title: "Sign in",
  mobileTitle: "Sign in",
  path: SIGN_IN_PATH,
  showTab: function showTab(_ref32) {
    var consumerAccount = _ref32.consumerAccount,
      showMobileItems = _ref32.showMobileItems;
    return showMobileItems && consumerAccount == null;
  },
  icon: /* @__PURE__ */React27.createElement(EzIcon, {
    icon: faArrowRightToBracket
  })
}, {
  title: "Create an account",
  mobileTitle: "Create an account",
  path: SIGN_UP_PATH,
  showTab: function showTab(_ref33) {
    var consumerAccount = _ref33.consumerAccount,
      showMobileItems = _ref33.showMobileItems;
    return showMobileItems && consumerAccount == null;
  },
  icon: /* @__PURE__ */React27.createElement(EzIcon, {
    icon: faCirclePlus
  })
}];
var myAccountLinks_default = myAccountLinks;

// src/components/AppBar/components/ProfileAppBarItem/utils.ts
var formatPoints = function formatPoints(points) {
  var symbolLookup = [{
    value: 1e6,
    symbol: "m"
  }, {
    value: 1e3,
    symbol: "k"
  }, {
    value: 1,
    symbol: ""
  }];
  var regexp = /\.0+$|(?<=\.[0-9]*[1-9])0+$/;
  var symbol = symbolLookup.find(function (_ref34) {
    var value = _ref34.value;
    return points >= value;
  });
  return symbol ? new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 2
  }).format(symbol.value > 1 ? Math.floor(points / symbol.value * 100) / 100 : points).replace(regexp, "").concat(symbol.symbol) : "0";
};
var linkSubText = function linkSubText(subText, subTextProps) {
  return typeof subText === "function" ? subText(subTextProps) : subText;
};

// src/components/AppBar/components/ProfileAppBarItem/MyAccountNav.tsx
var MyAccountNav = function MyAccountNav(_ref35) {
  var buttonRef = _ref35.buttonRef,
    currentUser = _ref35.currentUser,
    _ref35$showLogout = _ref35.showLogout,
    showLogout = _ref35$showLogout === void 0 ? false : _ref35$showLogout,
    _ref35$showSubText = _ref35.showSubText,
    showSubText = _ref35$showSubText === void 0 ? false : _ref35$showSubText,
    _ref35$showIcon = _ref35.showIcon,
    showIcon = _ref35$showIcon === void 0 ? false : _ref35$showIcon,
    track = _ref35.track,
    trackLink = _ref35.trackLink,
    corpPortalHost = _ref35.corpPortalHost,
    _ref35$pointsGivenFor = _ref35.pointsGivenForReview,
    pointsGivenForReview = _ref35$pointsGivenFor === void 0 ? 100 : _ref35$pointsGivenFor;
  var pathname = window.location.pathname;
  var consumerAccount = currentUser == null ? void 0 : currentUser.consumerAccount;
  var adminAccount = currentUser == null ? void 0 : currentUser.adminAccount;
  var linkFilter = function linkFilter(link) {
    var _ref36;
    var _a;
    return (_ref36 = (_a = link.showTab) == null ? void 0 : _a.call(link, {
      consumerAccount: consumerAccount,
      adminAccount: adminAccount,
      showMobileItems: false
    })) !== null && _ref36 !== void 0 ? _ref36 : true;
  };
  var trackRef = useLatest(track);
  useEffect(function () {
    var _a;
    (_a = trackRef.current) == null ? void 0 : _a.call(trackRef, "appbar-profile-menu-opened", {
      url: window.location.href,
      misc_json: JSON.stringify({
        area: "desktop"
      })
    });
  }, [trackRef]);
  return /* @__PURE__ */React27.createElement(EzPopover, {
    targetRef: buttonRef,
    shouldCloseOnBlur: true,
    onClose: function onClose() {
      return null;
    }
  }, /* @__PURE__ */React27.createElement(NavDropdownMenu, null, myAccountLinks_default.filter(linkFilter).map(function (link) {
    var linkPath = typeof link.path === "function" ? link.path({
      corpPortalHost: corpPortalHost
    }) : link.path;
    return /* @__PURE__ */React27.createElement(NavDropdownMenuItem, {
      key: link.title
    }, /* @__PURE__ */React27.createElement(NavDropdownNavLink, {
      href: compilePath_default(link.path),
      title: "Navigates to ".concat(link.title, " page"),
      className: pathname.includes(linkPath) ? "active" : "",
      onClick: function onClick() {
        return trackLink(linkPath, link.title);
      }
    }, showIcon && /* @__PURE__ */React27.createElement(IconContainer, null, link.icon), link.title, showSubText && link.subText && /* @__PURE__ */React27.createElement(SubText, null, linkSubText(link.subText, {
      pointsGivenForReview: pointsGivenForReview
    }))));
  }), showLogout && consumerAccount && /* @__PURE__ */React27.createElement(NavDropdownMenuItem, null, /* @__PURE__ */React27.createElement("form", {
    method: "POST",
    action: SIGN_OUT_PATH
  }, /* @__PURE__ */React27.createElement("input", {
    type: "hidden",
    name: "_method",
    value: "delete"
  }), /* @__PURE__ */React27.createElement(NavDropdownNavButton, {
    type: "submit",
    title: "Navigates to sign out page"
  }, "Not ".concat(consumerAccount == null ? void 0 : consumerAccount.fullName, "? Sign out"))))));
};
var MyAccountNav_default = MyAccountNav;

// src/components/AppBar/components/ProfileAppBarItem/ProfileAppBarItem.tsx
var ProfileAppBarMouseContainer = styled22.div(_templateObject71 || (_templateObject71 = _taggedTemplateLiteral(["\n  padding: 12px;\n  padding-left: 0;\n"])));
var ProfileAppBarItem = function ProfileAppBarItem(_ref37) {
  var currentUser = _ref37.currentUser,
    track = _ref37.track,
    trackLink = _ref37.trackLink,
    corpPortalHost = _ref37.corpPortalHost,
    _ref37$pointsGivenFor = _ref37.pointsGivenForReview,
    pointsGivenForReview = _ref37$pointsGivenFor === void 0 ? 100 : _ref37$pointsGivenFor;
  var _useToggleState_defau3 = useToggleState_default(),
    isOpen = _useToggleState_defau3.toggleValue,
    show = _useToggleState_defau3.on,
    hide = _useToggleState_defau3.off;
  var buttonRef = useRef(null);
  return /* @__PURE__ */React27.createElement(ProfileAppBarMouseContainer, {
    onMouseEnter: show,
    onMouseLeave: hide
  }, /* @__PURE__ */React27.createElement(StyledEzButton2, {
    legacy: true,
    use: "tertiary",
    ref: buttonRef,
    "data-testid": "profile-nav-bar-item"
  }, /* @__PURE__ */React27.createElement(StyledEzIcon2, {
    icon: faCircleUser
  })), isOpen && /* @__PURE__ */React27.createElement(MyAccountNav_default, {
    buttonRef: buttonRef,
    currentUser: currentUser,
    showLogout: true,
    showSubText: true,
    track: track,
    trackLink: trackLink,
    corpPortalHost: corpPortalHost,
    pointsGivenForReview: pointsGivenForReview
  }));
};
var ProfileAppBarItem_default = ProfileAppBarItem;
styled22.ul(_templateObject72 || (_templateObject72 = _taggedTemplateLiteral(["\n  margin: 0;\n  padding: 0;\n  list-style: none;\n"])));
var ModalContent = styled22.div(_templateObject73 || (_templateObject73 = _taggedTemplateLiteral(["\n  padding: 0 30px !important;\n"])));
var NeedHelpContent = styled22.div(_templateObject74 || (_templateObject74 = _taggedTemplateLiteral(["\n  margin-top: 10px;\n  color: ", ";\n  \n  a {\n    text-decoration: none;\n    color: ", ";\n\n  }\n\n  a + a {\n    margin-left: 10px};\n  }\n"])), colors_default.gray500, colors_default.gray500);
var useIsomorphicLayoutEffect = typeof window === "undefined" ? useEffect : useLayoutEffect;
var useIsomorphicLayoutEffect_default = useIsomorphicLayoutEffect;

// src/components/AppBar/components/ProfileAppBarItem/FocusScope/FocusScope.tsx
var activeScope = null;
var scopes = /* @__PURE__ */new Set();
var FocusScope_default = React27.forwardRef(function FocusScope(props, ref) {
  var children = props.children,
    contain = props.contain,
    restoreFocus = props.restoreFocus,
    autoFocus = props.autoFocus;
  var startRef = useRef();
  var endRef = useRef();
  var scopeRef = useRef([]);
  useIsomorphicLayoutEffect_default(function () {
    var node = startRef.current.nextSibling;
    var nodes = [];
    while (node && node !== endRef.current) {
      nodes.push(node);
      node = node.nextSibling;
    }
    scopeRef.current = nodes;
    scopes.add(scopeRef);
    return function () {
      scopes.delete(scopeRef);
    };
  }, [children]);
  useFocusContainment(scopeRef, contain);
  useRestoreFocus(scopeRef, restoreFocus, contain);
  useAutoFocus(scopeRef, autoFocus);
  React27.useImperativeHandle(ref, function () {
    return {
      focusFirstInScope: function focusFirstInScope() {
        return _focusFirstInScope(scopeRef.current);
      }
    };
  });
  return /* @__PURE__ */React27.createElement(React27.Fragment, null, /* @__PURE__ */React27.createElement("span", {
    hidden: true,
    ref: startRef
  }), children, /* @__PURE__ */React27.createElement("span", {
    hidden: true,
    ref: endRef
  }));
});
var focusableElements = ["input:not([disabled]):not([type=hidden])", "select:not([disabled])", "textarea:not([disabled])", "button:not([disabled])", "a[href]", "area[href]", "summary", "iframe", "object", "embed", "audio[controls]", "video[controls]", "[contenteditable]"];
focusableElements.push('[tabindex]:not([tabindex="-1"])');
var TABBABLE_ELEMENT_SELECTOR = focusableElements.join(':not([tabindex="-1"]),');
function getFocusableElementsInScope(scope) {
  var res = [];
  var selector = TABBABLE_ELEMENT_SELECTOR;
  scope.forEach(function (node) {
    if (node.matches(selector)) res.push(node);
    res.push.apply(res, _toConsumableArray(Array.from(node.querySelectorAll(selector))));
  });
  return res;
}
function useFocusContainment(scopeRef, contain) {
  var focusedNode = useRef();
  var raf = useRef(null);
  useEffect(function () {
    var scope = scopeRef.current;
    if (!contain) return;
    var document2 = getDocument(scope[0]);
    var onKeyDown = function onKeyDown(e) {
      if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || e.defaultPrevented) return;
      var focusedElement = document2.activeElement;
      if (!isElementInScope(focusedElement, scope)) return;
      var elements = getFocusableElementsInScope(scope);
      var position = elements.indexOf(focusedElement);
      var lastPosition = elements.length - 1;
      var nextElement = null;
      if (e.shiftKey) nextElement = elements[position <= 0 ? lastPosition : position - 1];else nextElement = elements[position === lastPosition ? 0 : position + 1];
      e.preventDefault();
      focusElement(nextElement);
    };
    var onFocus = function onFocus(e) {
      var _a;
      var isInAnyScope = isElementInAnyScope(e.target, scopes);
      if (!isInAnyScope) (_a = focusedNode.current) == null ? void 0 : _a.focus();else {
        e.stopPropagation();
        activeScope = scopeRef;
        focusedNode.current = e.target;
      }
    };
    var onBlur = function onBlur(e) {
      e.stopPropagation();
      if (!e.relatedTarget) return;
      var isInAnyScope = isElementInAnyScope(e.relatedTarget, scopes);
      if (!isInAnyScope) {
        activeScope = scopeRef;
        focusedNode.current = e.target;
        raf.current = requestAnimationFrame(function () {
          focusedNode.current.focus();
        });
      }
    };
    document2.addEventListener("keydown", onKeyDown, false);
    document2.addEventListener("focusin", onFocus, false);
    scope.forEach(function (element) {
      return element.addEventListener("focusin", onFocus, false);
    });
    scope.forEach(function (element) {
      return element.addEventListener("focusout", onBlur, false);
    });
    return function () {
      document2.removeEventListener("keydown", onKeyDown, false);
      document2.removeEventListener("focusin", onFocus, false);
      scope.forEach(function (element) {
        return element.removeEventListener("focusin", onFocus, false);
      });
      scope.forEach(function (element) {
        return element.removeEventListener("focusout", onBlur, false);
      });
    };
  }, [scopeRef, contain]);
  useEffect(function () {
    return function () {
      return cancelAnimationFrame(raf.current);
    };
  }, []);
}
function isElementInAnyScope(element, _scopes) {
  return Array.from(_scopes.values()).some(function (scope) {
    return isElementInScope(element, scope.current);
  });
}
function isElementInScope(element, scope) {
  return scope.some(function (node) {
    return node.contains(element);
  });
}
function focusElement(element) {
  try {
    element == null ? void 0 : element.focus();
  } catch (err) {}
}
function getDocument(element) {
  return element ? element.ownerDocument : document;
}
function _focusFirstInScope(scope) {
  var elements = getFocusableElementsInScope(scope);
  focusElement(elements[0]);
}
function useAutoFocus(scopeRef, autoFocus) {
  useEffect(function () {
    if (!autoFocus) return;
    activeScope = scopeRef;
    var document2 = getDocument(activeScope.current[0]);
    if (isElementInScope(document2.activeElement, activeScope.current)) return;
    _focusFirstInScope(scopeRef.current);
  }, [scopeRef, autoFocus]);
}
function useRestoreFocus(scopeRef, restoreFocus, contain) {
  useIsomorphicLayoutEffect_default(function () {
    var scope = scopeRef.current;
    var document2 = getDocument(scope[0]);
    var nodeToRestore = document2.activeElement;
    var onKeyDown = function onKeyDown(e) {
      if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey) return;
      var focusedElement = document2.activeElement;
      if (!isElementInScope(focusedElement, scope)) return;
      var walker = getFocusableTreeWalker(document2.body);
      walker.currentNode = focusedElement;
      var nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
      if ((!nextElement || !isElementInScope(nextElement, scope)) && nodeToRestore) {
        walker.currentNode = nodeToRestore;
        do nextElement = e.shiftKey ? walker.currentNode : walker.nextNode(); while (isElementInScope(nextElement, scope) && !e.shiftKey);
        e.preventDefault();
        e.stopPropagation();
        if (nextElement) nextElement.focus();else {
          focusedElement.blur();
        }
      }
    };
    if (!contain) document2.addEventListener("keydown", onKeyDown, true);
    return function () {
      if (!contain) document2.removeEventListener("keydown", onKeyDown, true);
      if (restoreFocus && nodeToRestore && isElementInScope(document2.activeElement, scope)) {
        requestAnimationFrame(function () {
          if (document2.body.contains(nodeToRestore)) focusElement(nodeToRestore);
        });
      }
    };
  }, [scopeRef, restoreFocus, contain]);
}
function getFocusableTreeWalker(root) {
  var selector = TABBABLE_ELEMENT_SELECTOR;
  var walker = root.ownerDocument.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
    acceptNode: function acceptNode(node) {
      if (node.matches(selector)) return NodeFilter.FILTER_ACCEPT;
      return NodeFilter.FILTER_SKIP;
    }
  }, false);
  return walker;
}
var PortalContext = React27.createContext({
  current: null
});
var Provider = PortalContext.Provider;
var Portal = function Portal(_ref38) {
  var children = _ref38.children;
  var mountNode = useRef(null);
  var _useContext = useContext(PortalContext),
    contextValue = _useContext.current;
  var contextRef = useRef(contextValue);
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    hostNode = _useState8[0],
    setHostNode = _useState8[1];
  useIsomorphicLayoutEffect_default(function () {
    var _a, _b;
    var context = contextRef.current;
    var parentElement = ((_a = mountNode.current) == null ? void 0 : _a.ownerDocument) === (context == null ? void 0 : context.ownerDocument) ? context : (_b = mountNode.current) == null ? void 0 : _b.ownerDocument.body;
    var portalNode = parentElement == null ? void 0 : parentElement.ownerDocument.createElement("div");
    if (portalNode) {
      parentElement == null ? void 0 : parentElement.appendChild(portalNode);
      setHostNode(portalNode);
      return function () {
        if (!(parentElement == null ? void 0 : parentElement.parentElement) || !(parentElement == null ? void 0 : parentElement.contains(portalNode))) return;
        parentElement.removeChild(portalNode);
      };
    }
    return null;
  }, []);
  if (!hostNode) return /* @__PURE__ */React27.createElement("div", {
    ref: mountNode
  });
  return /* @__PURE__ */React27.createElement(Provider, {
    value: {
      current: hostNode
    }
  }, createPortal(children, hostNode));
};
var Portal_default = Portal;
var useDialog = function useDialog(_ref39) {
  var onDismiss = _ref39.onDismiss;
  var onDismissRef = useLatest(onDismiss);
  var onKeyDown = useCallback(function (event) {
    if (event.defaultPrevented) return;
    if (event.key !== "Escape") return;
    event.stopPropagation();
    onDismissRef.current();
  }, [onDismissRef]);
  return {
    role: "dialog",
    "aria-modal": true,
    tabIndex: -1,
    onKeyDown: onKeyDown
  };
};
var useDialog_default = useDialog;
var Overlay = styled22.div(_templateObject75 || (_templateObject75 = _taggedTemplateLiteral(["\n  align-items: center;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 10;\n"])));
var Dialog = styled22.div(_templateObject76 || (_templateObject76 = _taggedTemplateLiteral(["\n  background: ", ";\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  max-height: 100vh;\n  outline: none;\n  width: 100%;\n  /* IE fix to prevent flex items overflowing. See: https://github.com/philipwalton/flexbugs#flexbug-3 */\n  overflow-y: auto;\n\n  &:focus {\n    box-shadow: 0px 0px 2px 2px ", ", 0 1px 1px 0 rgba(0, 0, 0, 0.12);\n  }\n\n  ", " {\n    border-radius: 0.75rem;\n  }\n"])), colors_default.white, colors_default.blue600, recipeMq_default("medium"));

// src/components/AppBar/components/ProfileAppBarItem/Modal/Modal.tsx
var noop = function noop() {};
var Modal2 = function Modal2(_ref40) {
  var id = _ref40.id,
    isOpen = _ref40.isOpen,
    _ref40$onDismiss = _ref40.onDismiss,
    onDismiss = _ref40$onDismiss === void 0 ? noop : _ref40$onDismiss,
    children = _ref40.children,
    className = _ref40.className;
  var dialog = useDialog_default({
    onDismiss: onDismiss
  });
  if (!isOpen) return null;
  return /* @__PURE__ */React27.createElement(Portal_default, null, /* @__PURE__ */React27.createElement(Overlay, {
    onClick: function onClick(e) {
      return e.target === e.currentTarget && onDismiss();
    }
  }, /* @__PURE__ */React27.createElement(ScrollLock_default, null), /* @__PURE__ */React27.createElement(FocusScope_default, {
    contain: true,
    restoreFocus: true,
    autoFocus: true
  }, /* @__PURE__ */React27.createElement(Dialog, _objectSpread(_objectSpread({}, dialog), {}, {
    "aria-labelledby": id,
    className: className
  }), children))));
};
var Modal_default2 = Modal2;
var StyledNavBarItem2 = styled22.div(_templateObject77 || (_templateObject77 = _taggedTemplateLiteral(["\n  padding: 11px 4px;\n  cursor: pointer;\n  position: relative;\n"])));
var StyledEzIcon6 = styled22(EzIcon)(_templateObject78 || (_templateObject78 = _taggedTemplateLiteral(["\n  margin-left: 6px;\n  font-size: 10px;\n"])));
var LandingDropdownMouseContainer = styled22.div(_templateObject79 || (_templateObject79 = _taggedTemplateLiteral(["\n  padding: 12px 0;\n  cursor: pointer;\n"])));
var LandingNavDropdownMenu = styled22(NavDropdownMenu)(_templateObject80 || (_templateObject80 = _taggedTemplateLiteral(["\n  right: -35px;\n"])));
var NavDropdownClickableItem = styled22.div(_templateObject81 || (_templateObject81 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  color: ", ";\n  text-decoration: none;\n  cursor: pointer;\n  padding-left: 10px;\n  height: 50px;\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.1);\n    color: ", ";\n  }\n"])), colors_default.gray500, colors_default.gray600);

// src/components/AppBar/components/LandingDropdownMenus/LandingDropdown.tsx
var LandingDropdown = function LandingDropdown(_ref41) {
  var navItemText = _ref41.navItemText,
    menuItems = _ref41.menuItems,
    trackLink = _ref41.trackLink,
    _ref41$testId = _ref41.testId,
    testId = _ref41$testId === void 0 ? "" : _ref41$testId;
  var _useToggleState_defau4 = useToggleState_default(),
    showDropdown = _useToggleState_defau4.toggleValue,
    show = _useToggleState_defau4.on,
    hide = _useToggleState_defau4.off;
  var navItemRef = useRef(null);
  return /* @__PURE__ */React27.createElement(LandingDropdownMouseContainer, {
    onMouseEnter: show,
    onMouseLeave: hide
  }, /* @__PURE__ */React27.createElement(StyledNavBarItem2, {
    "data-testid": testId
  }, navItemText, /* @__PURE__ */React27.createElement(StyledEzIcon6, {
    ref: navItemRef,
    icon: faChevronDown$1,
    size: "small"
  })), showDropdown && /* @__PURE__ */React27.createElement(EzPopover, {
    targetRef: navItemRef,
    shouldCloseOnBlur: true,
    onClose: function onClose() {
      return null;
    }
  }, /* @__PURE__ */React27.createElement(LandingNavDropdownMenu, null, menuItems.map(function (item) {
    return /* @__PURE__ */React27.createElement(NavDropdownMenuItem, {
      "data-testid": "landing-dropdown-menu-item",
      key: item.text
    }, item.link != null && /* @__PURE__ */React27.createElement(NavDropdownNavLink, {
      "data-testid": "landing-dropdown-menu-item-link",
      href: item.link,
      title: "Navigates to ".concat(item.text, " page"),
      onClick: function onClick() {
        return trackLink(item.link || "", item.text);
      }
    }, item.text), item.onClick && /* @__PURE__ */React27.createElement(NavDropdownClickableItem, {
      "data-testid": "landing-dropdown-menu-item-link",
      title: "Opens ".concat(item.text),
      onClick: function onClick() {
        var _a;
        trackLink(item.link || "", item.text);
        (_a = item.onClick) == null ? void 0 : _a.call(item);
      }
    }, item.text));
  }))));
};
var LandingDropdown_default = LandingDropdown;
var StyledEzIcon7 = styled22(EzIcon)(_templateObject82 || (_templateObject82 = _taggedTemplateLiteral(["\n  margin-left: auto;\n  margin-right: 0;\n"])));
var MobileLandingNavDropdownMenu = styled22.div(_templateObject83 || (_templateObject83 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  background: ", ";\n"])), colors_default.gray200);
var NavDropdownClickableItem2 = styled22.div(_templateObject84 || (_templateObject84 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  color: ", ";\n  text-decoration: none;\n  cursor: pointer;\n  padding-left: 10px;\n  height: 50px;\n"])), colors_default.gray500);

// src/components/AppBar/components/LandingDropdownMenus/MobileLandingDropdown.tsx
var MobileLandingDropdown = function MobileLandingDropdown(_ref42) {
  var navItemText = _ref42.navItemText,
    menuItems = _ref42.menuItems,
    trackLink = _ref42.trackLink,
    _ref42$testId = _ref42.testId,
    testId = _ref42$testId === void 0 ? "" : _ref42$testId;
  var _useToggleState_defau5 = useToggleState_default(),
    showDropdown = _useToggleState_defau5.toggleValue,
    toggleDropdown = _useToggleState_defau5.toggle;
  return /* @__PURE__ */React27.createElement(React27.Fragment, null, /* @__PURE__ */React27.createElement(NavDropdownMenuItem, null, /* @__PURE__ */React27.createElement("div", null, /* @__PURE__ */React27.createElement(NavDropdownClickableItem2, {
    "data-testid": testId,
    onClick: toggleDropdown
  }, navItemText, !showDropdown && /* @__PURE__ */React27.createElement(StyledEzIcon7, {
    "data-testid": "mobile-chevron-down",
    icon: faChevronDown
  }), showDropdown && /* @__PURE__ */React27.createElement(StyledEzIcon7, {
    "data-testid": "mobile-chevron-up",
    icon: faChevronUp
  })))), showDropdown && /* @__PURE__ */React27.createElement(MobileLandingNavDropdownMenu, null, menuItems.map(function (item) {
    return /* @__PURE__ */React27.createElement(NavDropdownMenuItem, {
      "data-testid": "landing-dropdown-menu-item",
      key: item.text
    }, item.link && /* @__PURE__ */React27.createElement(NavDropdownNavLink, {
      "data-testid": "landing-dropdown-menu-item-link",
      href: item.link,
      title: "Navigates to ".concat(item.text, " page"),
      onClick: function onClick() {
        return trackLink(item.link || "", item.text);
      }
    }, item.text), item.onClick && /* @__PURE__ */React27.createElement(NavDropdownClickableItem2, {
      "data-testid": "landing-dropdown-menu-item-link",
      title: "Opens ".concat(item.text),
      onClick: function onClick() {
        var _a;
        trackLink(item.link || "", item.text);
        (_a = item.onClick) == null ? void 0 : _a.call(item);
      }
    }, item.text));
  })));
};
var MobileLandingDropdown_default = MobileLandingDropdown;

// src/components/AppBar/components/LandingDropdownMenus/LandingDropdownMenus.tsx
var LandingDropdownMenus = function LandingDropdownMenus(_ref43) {
  var trackLink = _ref43.trackLink;
  var companyDropdownItems = [{
    text: "Corporate catering overview",
    link: "/company/corporate-solutions/",
    trackingName: "nav-corp-solutions-overview"
  }, {
    text: "Meetings & events catering",
    link: "/company/corporate-solutions/catered-meetings-and-events",
    trackingName: "nav-catered-meetings-events"
  }, {
    text: "Employee meal programs",
    link: "/company/corporate-solutions/recurring-employee-meals",
    trackingName: "nav-recurring-employee-meals"
  }, {
    text: "Concierge ordering",
    link: "/company/corporate-solutions/concierge-ordering",
    trackingName: "nav-special-orders-services"
  }, {
    text: "Food spend management tools",
    link: "/company/corporate-solutions/food-spend-management",
    trackingName: "nav-food-spend-mgmt"
  }, {
    text: "Tax-exempt ordering",
    link: "/company/corporate-solutions/tax-exempt",
    trackingName: "nav-tax-exempt"
  }];
  var restaurantDropdownItems = [{
    text: "Sign in to ezManage",
    link: "/caterer_portal"
  }, {
    text: "Catering Growth Platform",
    link: "/company/catering-growth-platform/"
  }, {
    text: "Growth Solutions",
    link: "/company/catering-growth-platform/growth-solutions/"
  }, {
    text: "Catering Management Solutions",
    link: "/company/catering-growth-platform/catering-management-solutions/"
  }, {
    text: "Delivery Solutions",
    link: "/company/catering-growth-platform/delivery-solutions/"
  }, {
    text: "Help center",
    link: "https://catering.ezcater.com/en/help"
  }];
  var AboutUsDropdownItems = [{
    text: "Our story",
    link: "https://www.ezcater.com/company/about-us/"
  }, {
    text: "Our team",
    link: "https://www.ezcater.com/company/team/"
  }, {
    text: "Careers",
    link: "https://www.ezcater.com/company/careers/"
  }, {
    text: "News and events",
    link: "https://www.ezcater.com/company/news/"
  }, {
    text: "Blog",
    link: "https://www.ezcater.com/lunchrush/"
  }];
  return /* @__PURE__ */React27.createElement(React27.Fragment, null, /* @__PURE__ */React27.createElement(DesktopExperience_default, null, /* @__PURE__ */React27.createElement(EzLayout, {
    layout: "basic",
    alignY: "center"
  }, /* @__PURE__ */React27.createElement(LandingDropdown_default, {
    testId: "for-companies-dropdown",
    navItemText: "Corporate catering solutions",
    menuItems: companyDropdownItems,
    trackLink: trackLink
  }), /* @__PURE__ */React27.createElement(LandingDropdown_default, {
    testId: "for-restaurants-dropdown",
    navItemText: "For restaurants",
    menuItems: restaurantDropdownItems,
    trackLink: trackLink
  }), /* @__PURE__ */React27.createElement(LandingDropdown_default, {
    testId: "about-us-dropdown",
    navItemText: "About us",
    menuItems: AboutUsDropdownItems,
    trackLink: trackLink
  }))), /* @__PURE__ */React27.createElement(MobileAndTabletExperience_default, null, /* @__PURE__ */React27.createElement(MobileLandingDropdown_default, {
    testId: "for-companies-dropdown",
    navItemText: "Corporate catering solutions",
    menuItems: companyDropdownItems,
    trackLink: trackLink
  }), /* @__PURE__ */React27.createElement(MobileLandingDropdown_default, {
    testId: "for-restaurants-dropdown",
    navItemText: "For restaurants",
    menuItems: restaurantDropdownItems,
    trackLink: trackLink
  }), /* @__PURE__ */React27.createElement(MobileLandingDropdown_default, {
    testId: "about-us-dropdown",
    navItemText: "About us",
    menuItems: AboutUsDropdownItems,
    trackLink: trackLink
  })));
};
var LandingDropdownMenus_default = LandingDropdownMenus;
var ContactUsDropdownMenu = function ContactUsDropdownMenu(_ref44) {
  var openLibertyChat = _ref44.openLibertyChat,
    supportPhoneNumber = _ref44.supportPhoneNumber,
    supportFaxNumber = _ref44.supportFaxNumber,
    trackLink = _ref44.trackLink;
  var contactUsDropdownItems = [{
    text: "Send us a message",
    link: "https://www.ezcater.com/company/contact-us/"
  }, {
    text: "Email: support@ezcater.com",
    link: "mailto:support@ezcater.com"
  }];
  if (openLibertyChat) {
    contactUsDropdownItems.push({
      text: "Chat",
      onClick: openLibertyChat
    });
  }
  if (supportPhoneNumber) {
    contactUsDropdownItems.push({
      text: "Phone: ".concat(supportPhoneNumber),
      link: "tel:".concat(supportPhoneNumber)
    });
  }
  if (supportFaxNumber) {
    contactUsDropdownItems.push({
      text: "Fax: ".concat(supportFaxNumber),
      link: "fax:".concat(supportFaxNumber)
    });
  }
  return /* @__PURE__ */React27.createElement(React27.Fragment, null, /* @__PURE__ */React27.createElement(DesktopExperience_default, null, /* @__PURE__ */React27.createElement(EzLayout, {
    layout: "basic",
    alignY: "center"
  }, /* @__PURE__ */React27.createElement(LandingDropdown_default, {
    testId: "contact-us-dropdown",
    navItemText: "Contact Us",
    menuItems: contactUsDropdownItems,
    trackLink: trackLink
  }))), /* @__PURE__ */React27.createElement(MobileAndTabletExperience_default, null, /* @__PURE__ */React27.createElement(MobileLandingDropdown_default, {
    testId: "contact-us-dropdown",
    navItemText: "Contact Us",
    menuItems: contactUsDropdownItems,
    trackLink: trackLink
  })));
};
var ContactUsDropdownMenu_default = ContactUsDropdownMenu;

// src/components/AppBar/components/ProfileAppBarItem/ProfileMenuModal.tsx
var ProfileMenuModal = function ProfileMenuModal(_ref45) {
  var isOpen = _ref45.isOpen,
    onDismiss = _ref45.onDismiss,
    close = _ref45.close,
    currentUser = _ref45.currentUser,
    showSubText = _ref45.showSubText,
    supportPhoneNumber = _ref45.supportPhoneNumber,
    supportFaxNumber = _ref45.supportFaxNumber,
    _ref45$landingPage = _ref45.landingPage,
    landingPage = _ref45$landingPage === void 0 ? false : _ref45$landingPage,
    track = _ref45.track,
    trackLink = _ref45.trackLink,
    corpPortalHost = _ref45.corpPortalHost,
    _ref45$pointsGivenFor = _ref45.pointsGivenForReview,
    pointsGivenForReview = _ref45$pointsGivenFor === void 0 ? 100 : _ref45$pointsGivenFor;
  var pathname = window.location.pathname;
  var linkFilter = function linkFilter(link) {
    var _ref46;
    var _a;
    return (_ref46 = (_a = link.showTab) == null ? void 0 : _a.call(link, {
      consumerAccount: currentUser == null ? void 0 : currentUser.consumerAccount,
      adminAccount: currentUser == null ? void 0 : currentUser.adminAccount,
      canAccessCorpPortal: currentUser == null ? void 0 : currentUser.canAccessCorpPortal,
      showMobileItems: true
    })) !== null && _ref46 !== void 0 ? _ref46 : true;
  };
  var isLoggedIn2 = currentUser;
  var trackRef = useLatest(track);
  useEffect(function () {
    var _a;
    (_a = trackRef.current) == null ? void 0 : _a.call(trackRef, "appbar-profile-menu-opened", {
      url: window.location.href,
      misc_json: JSON.stringify({
        area: "mobile"
      })
    });
  }, [trackRef]);
  return /* @__PURE__ */React27.createElement(Modal_default2, {
    isOpen: isOpen,
    onDismiss: onDismiss
  }, /* @__PURE__ */React27.createElement(Toolbar, {
    layout: "split"
  }, /* @__PURE__ */React27.createElement(Logo2023_default, {
    trackLink: trackLink
  }), /* @__PURE__ */React27.createElement(EzButton, {
    legacy: true,
    use: "tertiary",
    onClick: close,
    style: {
      color: colors_default.darkGray
    }
  }, /* @__PURE__ */React27.createElement(EzIcon, {
    icon: faX,
    title: "Close menu"
  }))), /* @__PURE__ */React27.createElement(ModalContent, null, /* @__PURE__ */React27.createElement("h3", null, isLoggedIn2 ? "Welcome, ".concat(currentUser.consumerAccount.firstName) : "Welcome to ezCater!"), !isLoggedIn2 && landingPage && /* @__PURE__ */React27.createElement(React27.Fragment, null, /* @__PURE__ */React27.createElement(LandingDropdownMenus_default, {
    trackLink: trackLink
  }), /* @__PURE__ */React27.createElement(ContactUsDropdownMenu_default, {
    supportPhoneNumber: supportPhoneNumber,
    supportFaxNumber: supportFaxNumber,
    trackLink: trackLink
  })), myAccountLinks_default.filter(linkFilter).map(function (link) {
    var linkPath = typeof link.path === "function" ? link.path({
      corpPortalHost: corpPortalHost
    }) : link.path;
    var compiledPath = typeof link.path === "function" ? linkPath : compilePath_default(linkPath);
    return /* @__PURE__ */React27.createElement(NavDropdownMenuItem, {
      key: link.title
    }, /* @__PURE__ */React27.createElement(NavDropdownNavLink, {
      href: compiledPath,
      title: "Navigates to ".concat(link.title, " page"),
      className: pathname.includes(linkPath) ? "active" : "",
      onClick: function onClick() {
        return trackLink(linkPath, link.title);
      }
    }, /* @__PURE__ */React27.createElement(IconContainer, null, link.icon), link.title, showSubText && link.subText && /* @__PURE__ */React27.createElement(SubText, null, linkSubText(link.subText, {
      pointsGivenForReview: pointsGivenForReview
    }))));
  }), isLoggedIn2 && /* @__PURE__ */React27.createElement(NavDropdownMenuItem, null, /* @__PURE__ */React27.createElement("form", {
    method: "POST",
    action: SIGN_OUT_PATH
  }, /* @__PURE__ */React27.createElement("input", {
    type: "hidden",
    name: "_method",
    value: "delete"
  }), /* @__PURE__ */React27.createElement(NavDropdownNavButton, {
    type: "submit",
    title: "Navigates to sign out page"
  }, /* @__PURE__ */React27.createElement(IconContainer, null, /* @__PURE__ */React27.createElement(EzIcon, {
    icon: faArrowRightFromBracket,
    size: "small"
  })), "Not ".concat(currentUser.consumerAccount.fullName, "? Sign out")))), /* @__PURE__ */React27.createElement(NeedHelpContent, null, /* @__PURE__ */React27.createElement("h3", null, "Need help?"), /* @__PURE__ */React27.createElement("div", null, /* @__PURE__ */React27.createElement("a", {
    href: "tel:18004881803"
  }, "1-800-488-1803")), /* @__PURE__ */React27.createElement("div", null, /* @__PURE__ */React27.createElement("a", {
    href: "mailto:support@ezcater.com"
  }, "support@ezcater.com")))));
};
var ProfileMenuModal_default = ProfileMenuModal;
var Wrapper2 = styled22.div(_templateObject85 || (_templateObject85 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.75rem;\n"])));
var AppBarLink = styled22("a", {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== "justify";
  }
})(_templateObject86 || (_templateObject86 = _taggedTemplateLiteral(["\n  appearance: none;\n  border: 0;\n  background-color: inherit;\n  padding: 0.5rem 1rem;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: ", ";\n  border-radius: 0.25rem;\n  text-decoration: none;\n  text-underline-offset: 4px;\n  width: 100%;\n  cursor: pointer;\n  color: #000;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n\n  &:focus,\n  &:hover {\n    text-decoration: underline;\n    color: #000;\n  }\n"])), function (props) {
  return props.justify === "between" ? "space-between" : "flex-start";
});
var PillNavBarLink = styled22(AppBarLink)(_templateObject87 || (_templateObject87 = _taggedTemplateLiteral(["\n  &:focus,\n  &:hover {\n    text-decoration: none;\n    color: #000;\n\n    .link-container {\n      text-decoration: underline;\n    }\n  }\n"])));
var SignOutForm = styled22.form(_templateObject88 || (_templateObject88 = _taggedTemplateLiteral(["\n  display: block;\n  width: 100%;\n"])));
var SignOutButton = AppBarLink.withComponent("button");
var LinkContainer = styled22.div(_templateObject89 || (_templateObject89 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n"])));
var Divider = styled22.hr(_templateObject90 || (_templateObject90 = _taggedTemplateLiteral(["\n  width: 100%;\n  border-width: 0;\n  border-top-width: 1px;\n  border-style: solid;\n  border-color: #d6d9e1;\n  height: 0;\n  color: inherit;\n"])));
var PeppercornPill = styled22.div(_templateObject91 || (_templateObject91 = _taggedTemplateLiteral(["\n  color: #666974;\n  font-weight: 700;\n  font-size: 0.75rem;\n  line-height: 1rem;\n  padding: 0.25rem 0.5rem;\n  background-color: #f0f2f7;\n  border-radius: 9999px;\n"])));
var EzGreenPill = styled22(PeppercornPill)(_templateObject92 || (_templateObject92 = _taggedTemplateLiteral(["\n  color: #008054;\n  background-color: #d3faeb;\n"])));
var SemiSmallEzIcon = styled22(EzIcon)(_templateObject93 || (_templateObject93 = _taggedTemplateLiteral(["\n  font-size: 1.125rem !important;\n  flex-shrink: 0;\n"])));

// src/components/AppBar/components/ProfileAppBarItem/Ez429MyAccountNav.tsx
var Ez429MyAccountNav = function Ez429MyAccountNav(_ref47) {
  var currentUser = _ref47.currentUser,
    _ref47$showMobileItem = _ref47.showMobileItems,
    showMobileItems = _ref47$showMobileItem === void 0 ? false : _ref47$showMobileItem,
    track = _ref47.track,
    trackLink = _ref47.trackLink,
    area = _ref47.area,
    corpPortalHost = _ref47.corpPortalHost,
    _ref47$pointsGivenFor = _ref47.pointsGivenForReview,
    pointsGivenForReview = _ref47$pointsGivenFor === void 0 ? 100 : _ref47$pointsGivenFor;
  var _a;
  var consumerAccount = currentUser == null ? void 0 : currentUser.consumerAccount;
  var isLoggedIn2 = consumerAccount != null;
  var isAdmin = (currentUser == null ? void 0 : currentUser.adminAccount) != null;
  var trackRef = useLatest(track);
  useEffect(function () {
    var _a2;
    (_a2 = trackRef.current) == null ? void 0 : _a2.call(trackRef, "appbar-profile-menu-opened", {
      url: window.location.href,
      misc_json: JSON.stringify({
        area: area
      })
    });
  }, [area, trackRef]);
  return /* @__PURE__ */React27.createElement(Wrapper2, null, isLoggedIn2 ? /* @__PURE__ */React27.createElement(React27.Fragment, null, /* @__PURE__ */React27.createElement(AppBarLink, {
    href: compilePath_default(START_NEW_ORDER_PATH),
    title: "Navigates to Home page",
    onClick: function onClick() {
      return trackLink(compilePath_default(START_NEW_ORDER_PATH), "Home");
    }
  }, /* @__PURE__ */React27.createElement(LinkContainer, null, /* @__PURE__ */React27.createElement(SemiSmallEzIcon, {
    icon: faHouse
  }), "Home")), /* @__PURE__ */React27.createElement(AppBarLink, {
    href: compilePath_default(ORDERS_PATH),
    title: "Navigates to Orders page",
    onClick: function onClick() {
      return trackLink(compilePath_default(ORDERS_PATH), "Orders");
    }
  }, /* @__PURE__ */React27.createElement(LinkContainer, null, /* @__PURE__ */React27.createElement(SemiSmallEzIcon, {
    icon: faBowlHot
  }), "Orders")), /* @__PURE__ */React27.createElement(AppBarLink, {
    href: compilePath_default(SAVED_RESTAURANTS_PATH),
    title: "Navigates to Saved restaurants page",
    onClick: function onClick() {
      return trackLink(compilePath_default(SAVED_RESTAURANTS_PATH), "Saved restaurants");
    }
  }, /* @__PURE__ */React27.createElement(LinkContainer, null, /* @__PURE__ */React27.createElement(SemiSmallEzIcon, {
    icon: faBookmark
  }), "Saved restaurants")), /* @__PURE__ */React27.createElement(AppBarLink, {
    href: compilePath_default(RECEIPTS_PATH),
    title: "Navigates to Receipts page",
    onClick: function onClick() {
      return trackLink(compilePath_default(RECEIPTS_PATH), "Receipts");
    }
  }, /* @__PURE__ */React27.createElement(LinkContainer, null, /* @__PURE__ */React27.createElement(SemiSmallEzIcon, {
    icon: faReceipt
  }), "Receipts")), /* @__PURE__ */React27.createElement(AppBarLink, {
    href: compilePath_default(GROUP_POLLS_PATH),
    title: "Navigates to Group polls page",
    onClick: function onClick() {
      return trackLink(compilePath_default(GROUP_POLLS_PATH), "Group polls");
    }
  }, /* @__PURE__ */React27.createElement(LinkContainer, null, /* @__PURE__ */React27.createElement(SemiSmallEzIcon, {
    icon: faSquarePollVertical
  }), "Group polls")), /* @__PURE__ */React27.createElement(Divider, null), (currentUser == null ? void 0 : currentUser.consumerAccount.canCollectOwnEzRewards) && /* @__PURE__ */React27.createElement(PillNavBarLink, {
    href: compilePath_default(EZ_REWARDS_PATH),
    title: "Navigates to ezRewards page",
    onClick: function onClick() {
      return trackLink(compilePath_default(EZ_REWARDS_PATH), "ezRewards");
    },
    justify: "between"
  }, /* @__PURE__ */React27.createElement(LinkContainer, {
    className: "link-container"
  }, /* @__PURE__ */React27.createElement(SemiSmallEzIcon, {
    icon: faGift
  }), "ezRewards"), /* @__PURE__ */React27.createElement(PeppercornPill, null, "".concat(formatPoints(((_a = currentUser.consumerAccount.ezRewardsAccount) == null ? void 0 : _a.balance) || 0), " points"))), /* @__PURE__ */React27.createElement(PillNavBarLink, {
    href: compilePath_default(REVIEWS_PATH),
    title: "Navigates to Reviews page",
    onClick: function onClick() {
      return trackLink(compilePath_default(REVIEWS_PATH), "Reviews");
    },
    justify: "between"
  }, /* @__PURE__ */React27.createElement(LinkContainer, {
    className: "link-container"
  }, /* @__PURE__ */React27.createElement(SemiSmallEzIcon, {
    icon: faPencil
  }), "Reviews"), /* @__PURE__ */React27.createElement(EzGreenPill, null, "+".concat(pointsGivenForReview, " points"))), /* @__PURE__ */React27.createElement(PillNavBarLink, {
    href: compilePath_default(REFER_A_FRIEND_PATH),
    title: "Navigates to Refer a friend page",
    onClick: function onClick() {
      return trackLink(compilePath_default(REFER_A_FRIEND_PATH), "Refer a friend");
    },
    justify: "between"
  }, /* @__PURE__ */React27.createElement(LinkContainer, {
    className: "link-container"
  }, /* @__PURE__ */React27.createElement(SemiSmallEzIcon, {
    icon: faMegaphone
  }), "Refer a friend"), /* @__PURE__ */React27.createElement(EzGreenPill, null, "+25,000 points")), /* @__PURE__ */React27.createElement(Divider, null), /* @__PURE__ */React27.createElement(AppBarLink, {
    href: compilePath_default(SUGGEST_RESTAURANT_PATH),
    title: "Navigates to Suggest a restaurant page",
    onClick: function onClick() {
      return trackLink(compilePath_default(SUGGEST_RESTAURANT_PATH), "Suggest a restaurant");
    }
  }, /* @__PURE__ */React27.createElement(LinkContainer, null, /* @__PURE__ */React27.createElement(SemiSmallEzIcon, {
    icon: faCommentPlus
  }), "Suggest a restaurant")), /* @__PURE__ */React27.createElement(AppBarLink, {
    href: compilePath_default(MY_PROFILE_PATH),
    title: "Navigates to Account settings page",
    onClick: function onClick() {
      return trackLink(compilePath_default(MY_PROFILE_PATH), "Account settings");
    }
  }, /* @__PURE__ */React27.createElement(LinkContainer, null, /* @__PURE__ */React27.createElement(SemiSmallEzIcon, {
    icon: faCog
  }), "Account settings")), /* @__PURE__ */React27.createElement(AppBarLink, {
    href: compilePath_default(ADDRESSES_PATH),
    title: "Navigates to Delivery addresses page",
    onClick: function onClick() {
      return trackLink(compilePath_default(ADDRESSES_PATH), "Delivery addresses");
    }
  }, /* @__PURE__ */React27.createElement(LinkContainer, null, /* @__PURE__ */React27.createElement(SemiSmallEzIcon, {
    icon: faLocationDot
  }), "Delivery addresses")), /* @__PURE__ */React27.createElement(AppBarLink, {
    href: compilePath_default(PAYMENT_METHODS_PATH),
    title: "Navigates to Payment methods page",
    onClick: function onClick() {
      return trackLink(compilePath_default(PAYMENT_METHODS_PATH), "Payment methods");
    }
  }, /* @__PURE__ */React27.createElement(LinkContainer, null, /* @__PURE__ */React27.createElement(SemiSmallEzIcon, {
    icon: faCreditCard
  }), "Payment methods")), (currentUser == null ? void 0 : currentUser.consumerAccount.canAccessConcur) && /* @__PURE__ */React27.createElement(AppBarLink, {
    href: compilePath_default(EXPENSE_REPORTING_PATH),
    title: "Navigates to Expense reporting page",
    onClick: function onClick() {
      return trackLink(compilePath_default(PAYMENT_METHODS_PATH), "Expense reporting");
    }
  }, /* @__PURE__ */React27.createElement(LinkContainer, null, /* @__PURE__ */React27.createElement(SemiSmallEzIcon, {
    icon: faMoneyCheckDollar
  }), "Expense reporting")), /* @__PURE__ */React27.createElement(Divider, null), isAdmin && showMobileItems && /* @__PURE__ */React27.createElement(AppBarLink, {
    href: compilePath_default(ADMIN_PATH),
    title: "Navigates to Admin page",
    onClick: function onClick() {
      return trackLink(compilePath_default(ADMIN_PATH), "Admin");
    }
  }, /* @__PURE__ */React27.createElement(LinkContainer, null, /* @__PURE__ */React27.createElement(SemiSmallEzIcon, {
    icon: faLockOpen
  }), "Admin")), (currentUser == null ? void 0 : currentUser.canAccessCorpPortal) && !!corpPortalHost && showMobileItems && /* @__PURE__ */React27.createElement(AppBarLink, {
    href: corpPortalHost,
    title: "Navigates to Corporate Admin page",
    onClick: function onClick() {
      return trackLink(corpPortalHost, "Corporate Admin");
    }
  }, /* @__PURE__ */React27.createElement(LinkContainer, null, /* @__PURE__ */React27.createElement(SemiSmallEzIcon, {
    icon: faBuildingUser
  }), "Corporate Admin")), consumerAccount && /* @__PURE__ */React27.createElement(SignOutForm, {
    method: "POST",
    action: SIGN_OUT_PATH
  }, /* @__PURE__ */React27.createElement("input", {
    type: "hidden",
    name: "_method",
    value: "delete"
  }), /* @__PURE__ */React27.createElement(SignOutButton, {
    type: "submit",
    title: "Navigates to sign out page"
  }, /* @__PURE__ */React27.createElement(LinkContainer, null, /* @__PURE__ */React27.createElement(SemiSmallEzIcon, {
    icon: faRightFromBracket
  }), "Not ".concat(consumerAccount == null ? void 0 : consumerAccount.fullName, "? Sign out"))))) : /* @__PURE__ */React27.createElement(React27.Fragment, null, /* @__PURE__ */React27.createElement(AppBarLink, {
    href: compilePath_default(SIGN_IN_PATH),
    title: "Navigates to Sign in page",
    onClick: function onClick() {
      return trackLink(compilePath_default(SIGN_IN_PATH), "Sign in");
    }
  }, /* @__PURE__ */React27.createElement(LinkContainer, null, /* @__PURE__ */React27.createElement(SemiSmallEzIcon, {
    icon: faArrowRightToBracket
  }), "Sign in")), /* @__PURE__ */React27.createElement(AppBarLink, {
    href: compilePath_default(SIGN_UP_PATH),
    title: "Navigates to Create an account page",
    onClick: function onClick() {
      return trackLink(compilePath_default(SIGN_UP_PATH), "Create an account");
    }
  }, /* @__PURE__ */React27.createElement(LinkContainer, null, /* @__PURE__ */React27.createElement(SemiSmallEzIcon, {
    icon: faCirclePlus
  }), "Create an account"))));
};
var Ez429MyAccountNav_default = Ez429MyAccountNav;
var CloseButton = styled22.button(_templateObject94 || (_templateObject94 = _taggedTemplateLiteral(["\n  appearance: none;\n  border: 0;\n  background-color: inherit;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 9999px;\n  padding: 0.5rem;\n  color: #212223;\n  cursor: pointer;\n\n  &:hover {\n    background-color: #f0f2f7;\n  }\n\n  &:active {\n    background-color: #d6d9e1;\n  }\n"])));
var ModalContent2 = styled22.div(_templateObject95 || (_templateObject95 = _taggedTemplateLiteral(["\n  padding: 1.5rem 1rem;\n"])));
var WelcomeMessage = styled22.h3(_templateObject96 || (_templateObject96 = _taggedTemplateLiteral(["\n  margin: 0 0 0.75rem 0;\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  font-weight: 400;\n  color: #000;\n"])));
var NeedHelpContent2 = styled22.div(_templateObject97 || (_templateObject97 = _taggedTemplateLiteral(["\n  margin-top: 0.75rem;\n  color: #000;\n  display: flex;\n  flex-direction: column;\n  padding: 0.5rem 1rem;\n  gap: 0.25rem;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n\n  a {\n    color: #000;\n    text-decoration: none;\n    text-underline-offset: 4px;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n"])));

// src/components/AppBar/components/ProfileAppBarItem/Ez429ProfileMenuModal.tsx
var Ez429ProfileMenuModal = function Ez429ProfileMenuModal(_ref48) {
  var isOpen = _ref48.isOpen,
    onDismiss = _ref48.onDismiss,
    close = _ref48.close,
    currentUser = _ref48.currentUser,
    supportPhoneNumber = _ref48.supportPhoneNumber,
    supportFaxNumber = _ref48.supportFaxNumber,
    _ref48$landingPage = _ref48.landingPage,
    landingPage = _ref48$landingPage === void 0 ? false : _ref48$landingPage,
    track = _ref48.track,
    trackLink = _ref48.trackLink,
    corpPortalHost = _ref48.corpPortalHost;
  var isLoggedIn2 = currentUser != null;
  return /* @__PURE__ */React27.createElement(Modal_default2, {
    isOpen: isOpen,
    onDismiss: onDismiss
  }, /* @__PURE__ */React27.createElement(Toolbar, {
    layout: "split"
  }, /* @__PURE__ */React27.createElement(Logo2023_default, {
    trackLink: trackLink
  }), /* @__PURE__ */React27.createElement(CloseButton, {
    type: "button",
    onClick: close
  }, /* @__PURE__ */React27.createElement(EzIcon, {
    icon: faXmark,
    title: "Close menu"
  }))), /* @__PURE__ */React27.createElement(ModalContent2, null, /* @__PURE__ */React27.createElement(WelcomeMessage, null, isLoggedIn2 ? "Welcome, ".concat(currentUser.consumerAccount.firstName) : "Welcome to ezCater!"), !isLoggedIn2 && landingPage && /* @__PURE__ */React27.createElement(React27.Fragment, null, /* @__PURE__ */React27.createElement(LandingDropdownMenus_default, {
    trackLink: trackLink
  }), /* @__PURE__ */React27.createElement(ContactUsDropdownMenu_default, {
    supportPhoneNumber: supportPhoneNumber,
    supportFaxNumber: supportFaxNumber,
    trackLink: trackLink
  })), /* @__PURE__ */React27.createElement(Ez429MyAccountNav_default, {
    track: track,
    trackLink: trackLink,
    area: "mobile",
    corpPortalHost: corpPortalHost,
    currentUser: currentUser,
    showMobileItems: true
  }), /* @__PURE__ */React27.createElement(NeedHelpContent2, null, /* @__PURE__ */React27.createElement("div", null, "Need help?"), /* @__PURE__ */React27.createElement("a", {
    href: "tel:18004881803"
  }, "1-800-488-1803"), /* @__PURE__ */React27.createElement("a", {
    href: "mailto:support@ezcater.com"
  }, "support@ezcater.com"))));
};
var Ez429ProfileMenuModal_default = Ez429ProfileMenuModal;

// src/components/AppBar/components/ProfileAppBarItem/MobileMenuBars.tsx
var StyledEzIconBars = styled22(EzIcon)(_templateObject98 || (_templateObject98 = _taggedTemplateLiteral(["\n  color: ", " !important;\n  margin: ", ";\n"])), colors_default.ezGreen, HAMBURGER_BUTTON_PADDING);
var StyledEzButton4 = styled22(EzButton)(_templateObject99 || (_templateObject99 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
var MobileMenuBars = function MobileMenuBars(_ref49) {
  var currentUser = _ref49.currentUser,
    supportPhoneNumber = _ref49.supportPhoneNumber,
    supportFaxNumber = _ref49.supportFaxNumber,
    _ref49$landingPage = _ref49.landingPage,
    landingPage = _ref49$landingPage === void 0 ? false : _ref49$landingPage,
    track = _ref49.track,
    trackLink = _ref49.trackLink,
    corpPortalHost = _ref49.corpPortalHost,
    useEz429Profile = _ref49.useEz429Profile,
    ez429TrackExposure = _ref49.ez429TrackExposure,
    _ref49$pointsGivenFor = _ref49.pointsGivenForReview,
    pointsGivenForReview = _ref49$pointsGivenFor === void 0 ? 100 : _ref49$pointsGivenFor;
  var _useToggleState_defau6 = useToggleState_default(),
    isOpen = _useToggleState_defau6.toggleValue,
    toggle = _useToggleState_defau6.toggle,
    off = _useToggleState_defau6.off;
  var buttonRef = useRef(null);
  var ez429CallbackRef = useLatest(ez429TrackExposure);
  useEffect(function () {
    var _a;
    if (isOpen) {
      (_a = ez429CallbackRef.current) == null ? void 0 : _a.call(ez429CallbackRef);
    }
  }, [isOpen, ez429CallbackRef]);
  return /* @__PURE__ */React27.createElement(React27.Fragment, null, /* @__PURE__ */React27.createElement(StyledEzButton4, {
    legacy: true,
    "aria-label": "Open menu",
    "data-testid": "mobile-menu-button",
    use: "tertiary",
    ref: buttonRef,
    onClick: toggle,
    onKeyDown: function onKeyDown(e) {
      return e.key === "Escape" && off;
    }
  }, /* @__PURE__ */React27.createElement(StyledEzIconBars, {
    icon: faBars,
    size: "medium"
  })), isOpen && (useEz429Profile ? /* @__PURE__ */React27.createElement(Ez429ProfileMenuModal_default, {
    isOpen: isOpen,
    close: off,
    onDismiss: off,
    currentUser: currentUser,
    supportPhoneNumber: supportPhoneNumber,
    supportFaxNumber: supportFaxNumber,
    landingPage: landingPage,
    trackLink: trackLink,
    corpPortalHost: corpPortalHost,
    track: track
  }) : /* @__PURE__ */React27.createElement(ProfileMenuModal_default, {
    isOpen: isOpen,
    close: off,
    onDismiss: off,
    currentUser: currentUser,
    supportPhoneNumber: supportPhoneNumber,
    supportFaxNumber: supportFaxNumber,
    landingPage: landingPage,
    trackLink: trackLink,
    showSubText: false,
    corpPortalHost: corpPortalHost,
    track: track,
    pointsGivenForReview: pointsGivenForReview
  })));
};
var MobileMenuBars_default = MobileMenuBars;
var consumerCartQuery = "\n  query openOrders {\n    me {\n      consumerAccount {\n        accountIdentifier\n      }\n    }\n    identity {\n      fulfillmentDetails {\n        edges {\n          node {\n            id\n            eventName\n            consumerCarts {\n              id\n              caterer {\n                id\n                urlId\n                name\n                address {\n                  city\n                  state\n                }\n              }\n            }\n            order {\n              id\n              updatedAt\n            }\n            corpAccount {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n";
var useConsumerCartQuery = function useConsumerCartQuery(federationUrl, fetcher) {
  var _useState9 = useState(true),
    _useState10 = _slicedToArray(_useState9, 2),
    isLoading = _useState10[0],
    setIsLoading = _useState10[1];
  var _useState11 = useState(void 0),
    _useState12 = _slicedToArray(_useState11, 2),
    error = _useState12[0],
    setError = _useState12[1];
  var _useState13 = useState({
      data: void 0
    }),
    _useState14 = _slicedToArray(_useState13, 2),
    response = _useState14[0],
    setResponse = _useState14[1];
  var _useCookies = useCookies(["tid"]),
    _useCookies2 = _slicedToArray(_useCookies, 1),
    cookies = _useCookies2[0];
  var onRequestSuccess = function onRequestSuccess(resp) {
    if (!resp) {
      return;
    }
    resp.json().then(function (json) {
      setResponse(json);
      setIsLoading(false);
    });
  };
  useEffect(function () {
    if (cookies.tid && typeof window !== "undefined") {
      var redDotCache = null;
      try {
        redDotCache = JSON.parse(localStorage == null ? void 0 : localStorage.getItem("redDotCache"));
      } catch (e) {}
      if (redDotCache && redDotCache[cookies.tid]) setResponse(redDotCache[cookies.tid]);
    }
  }, [cookies]);
  useEffect(function () {
    if (cookies.tid && response.data) {
      try {
        localStorage == null ? void 0 : localStorage.setItem("redDotCache", JSON.stringify(_defineProperty({}, cookies.tid, response)));
      } catch (e) {}
    }
  }, [response, cookies]);
  useEffect(function () {
    try {
      var fetch = fetcher || window.fetch;
      fetch(federationUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        mode: "cors",
        cache: "no-cache",
        credentials: "include",
        body: JSON.stringify({
          query: consumerCartQuery
        })
      }).then(function (resp) {
        return onRequestSuccess(resp);
      });
    } catch (e) {
      setIsLoading(false);
      setError(e);
      setResponse({
        data: void 0
      });
    }
  }, [federationUrl, fetcher]);
  return {
    loading: isLoading,
    data: response.data,
    error: error
  };
};
var useConsumerCartQuery_default = useConsumerCartQuery;
var ProfileAppBarMouseContainer2 = styled22.div(_templateObject100 || (_templateObject100 = _taggedTemplateLiteral(["\n  padding: 12px;\n  padding-left: 0;\n"])));
var ProfileButton = styled22("button", {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== "isOpen";
  }
})(_templateObject101 || (_templateObject101 = _taggedTemplateLiteral(["\n  appearance: none;\n  cursor: pointer;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0.5rem;\n  border-radius: 0.5rem;\n  border: 1px solid #d6d9e1;\n  padding: 0.5rem 2rem 0.5rem 0.75rem;\n  font-weight: 700;\n  height: 2.5rem;\n  width: 9rem;\n  color: #212223;\n  background-color: ", ";\n  font-family: ", ";\n  text-align: left;\n\n  &:hover {\n    background-color: #eafff9;\n  }\n\n  &:focus-visible {\n    outline: transparent solid 2px;\n    outline-offset: 2px;\n    box-shadow: rgb(255, 255, 255) 0px 0px 0px 1px, rgb(33, 34, 35) 0px 0px 0px 3.5px,\n      rgba(0, 0, 0, 0) 0px 0px 0px 0px;\n  }\n"])), function (_ref50) {
  var isOpen = _ref50.isOpen;
  return isOpen ? "#eafff9" : "#fff";
}, fonts_default.fontFamilyBase);
var StyledEzIcon8 = styled22(EzIcon)(_templateObject102 || (_templateObject102 = _taggedTemplateLiteral(["\n  flex-shrink: 0;\n  font-size: 1.125rem !important;\n"])));
var StyledChevron = styled22(EzIcon)(_templateObject103 || (_templateObject103 = _taggedTemplateLiteral(["\n  height: 100%;\n  position: absolute;\n  right: 0.5rem;\n  top: 0;\n  font-size: 1rem;\n"])));
var NameContainer = styled22.div(_templateObject104 || (_templateObject104 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n"])));
var Name = styled22.div(_templateObject105 || (_templateObject105 = _taggedTemplateLiteral(["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 0.875rem;\n  line-height: 1.25;\n  font-weight: 700;\n"])));
var Points = styled22(Name)(_templateObject106 || (_templateObject106 = _taggedTemplateLiteral(["\n  color: #2f7f00;\n  font-size: 0.75rem;\n"])));
var NavDropdownMenu2 = styled22.div(_templateObject107 || (_templateObject107 = _taggedTemplateLiteral(["\n  padding: 1.5rem 1rem;\n  margin: 8px 10px 10px;\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: 8px;\n  box-shadow: 0 2px 20px 0 rgba(153, 153, 153, 0.35);\n  position: absolute;\n  top: 0;\n  right: -82px;\n  width: 340px;\n  z-index: 10000 !important;\n\n  &::before {\n    cursor: pointer;\n    z-index: -1;\n    top: -9px;\n    bottom: 100%;\n    right: 16px;\n    content: '';\n    position: absolute;\n    height: 16px;\n    width: 16px;\n    transform: translateX(0px) rotate(45deg);\n    transform-origin: center;\n    border-left: 1px solid ", ";\n    border-top: 1px solid ", ";\n    background-color: ", ";\n  }\n"])), colors_default.white, colors_default.gray300, colors_default.gray300, colors_default.gray300, colors_default.white);

// src/components/AppBar/components/ProfileAppBarItem/Ez429ProfileAppBarItem.tsx
var Ez429ProfileAppBarItem = function Ez429ProfileAppBarItem(_ref51) {
  var currentUser = _ref51.currentUser,
    track = _ref51.track,
    trackLink = _ref51.trackLink,
    _ref51$pointsGivenFor = _ref51.pointsGivenForReview,
    pointsGivenForReview = _ref51$pointsGivenFor === void 0 ? 100 : _ref51$pointsGivenFor;
  var _a;
  var _useToggleState_defau7 = useToggleState_default(),
    isOpen = _useToggleState_defau7.toggleValue,
    show = _useToggleState_defau7.on,
    hide = _useToggleState_defau7.off;
  var buttonRef = useRef(null);
  return /* @__PURE__ */React27.createElement(ProfileAppBarMouseContainer2, {
    onMouseEnter: show,
    onMouseLeave: hide
  }, /* @__PURE__ */React27.createElement(ProfileButton, {
    type: "button",
    ref: buttonRef,
    "data-testid": "profile-nav-bar-item",
    isOpen: isOpen
  }, /* @__PURE__ */React27.createElement(StyledEzIcon8, {
    icon: faCircleUser
  }), /* @__PURE__ */React27.createElement(NameContainer, null, /* @__PURE__ */React27.createElement(Name, null, currentUser == null ? void 0 : currentUser.consumerAccount.firstName), (currentUser == null ? void 0 : currentUser.consumerAccount.enrolledInEzRewards) && currentUser.consumerAccount.canCollectOwnEzRewards && /* @__PURE__ */React27.createElement(Points, null, formatPoints(((_a = currentUser.consumerAccount.ezRewardsAccount) == null ? void 0 : _a.balance) || 0), " pts")), /* @__PURE__ */React27.createElement(StyledChevron, {
    icon: faChevronDown
  })), isOpen && /* @__PURE__ */React27.createElement(EzPopover, {
    targetRef: buttonRef,
    shouldCloseOnBlur: true,
    onClose: function onClose() {
      return null;
    }
  }, /* @__PURE__ */React27.createElement(NavDropdownMenu2, null, /* @__PURE__ */React27.createElement(Ez429MyAccountNav_default, {
    currentUser: currentUser,
    track: track,
    trackLink: trackLink,
    area: "desktop",
    pointsGivenForReview: pointsGivenForReview
  }))));
};
var Ez429ProfileAppBarItem_default = Ez429ProfileAppBarItem;

// src/components/AppBar/AppBar.tsx
var formatConsumerCart = function formatConsumerCart(_ref52) {
  var consumerCart = _ref52.consumerCart,
    eventName = _ref52.eventName,
    updatedAt = _ref52.updatedAt,
    accountName = _ref52.accountName;
  return {
    eventName: eventName,
    id: consumerCart == null ? void 0 : consumerCart.id,
    caterer: consumerCart.caterer,
    updatedAt: updatedAt,
    accountName: accountName
  };
};
var formatOrders = function formatOrders(_ref53) {
  var fulfillmentDetails = _ref53.fulfillmentDetails;
  var _a;
  if (fulfillmentDetails) {
    return (_a = fulfillmentDetails.edges) == null ? void 0 : _a.flatMap(function (fulfillmentDetail) {
      var _a2;
      return (_a2 = fulfillmentDetail.node.consumerCarts) == null ? void 0 : _a2.map(function (cart) {
        var _a3, _b, _c;
        return formatConsumerCart({
          consumerCart: cart,
          eventName: fulfillmentDetail.node.eventName,
          updatedAt: (_a3 = fulfillmentDetail.node.order) == null ? void 0 : _a3.updatedAt,
          accountName: (_c = (_b = fulfillmentDetail.node) == null ? void 0 : _b.corpAccount) == null ? void 0 : _c.name
        });
      });
    });
  }
  return [];
};
var AppBar = function AppBar(_ref54) {
  var federationUrl = _ref54.federationUrl,
    fetcher = _ref54.fetcher,
    onError = _ref54.onError,
    startNewOrderPath = _ref54.startNewOrderPath,
    _ref54$loginPath = _ref54.loginPath,
    loginPath = _ref54$loginPath === void 0 ? compilePath_default(SIGN_IN_PATH) : _ref54$loginPath,
    compileOrderPath = _ref54.compileOrderPath,
    onLoadData = _ref54.onLoadData,
    onOpen = _ref54.onOpen,
    onClickOrder = _ref54.onClickOrder,
    menuPageClickHandler = _ref54.menuPageClickHandler,
    cartHasItems = _ref54.cartHasItems,
    contactUsNavItemHandler = _ref54.contactUsNavItemHandler,
    notifications = _ref54.notifications,
    currentUser = _ref54.currentUser,
    supportPhoneNumber = _ref54.supportPhoneNumber,
    supportFaxNumber = _ref54.supportFaxNumber,
    openLibertyChat = _ref54.openLibertyChat,
    onStartNewOrderClick = _ref54.onStartNewOrderClick,
    _ref54$simplified = _ref54.simplified,
    simplified = _ref54$simplified === void 0 ? false : _ref54$simplified,
    _ref54$landingPage = _ref54.landingPage,
    landingPage = _ref54$landingPage === void 0 ? false : _ref54$landingPage,
    track = _ref54.track,
    _ref54$cartId = _ref54.cartId,
    cartId = _ref54$cartId === void 0 ? null : _ref54$cartId,
    corpPortalHost = _ref54.corpPortalHost,
    _ref54$useEz429Profil = _ref54.useEz429Profile,
    useEz429Profile = _ref54$useEz429Profil === void 0 ? false : _ref54$useEz429Profil,
    ez429TrackExposure = _ref54.ez429TrackExposure,
    _ref54$pointsGivenFor = _ref54.pointsGivenForReview,
    pointsGivenForReview = _ref54$pointsGivenFor === void 0 ? 100 : _ref54$pointsGivenFor,
    _ref54$channelPartner = _ref54.channelPartnerLogoUrl,
    channelPartnerLogoUrl = _ref54$channelPartner === void 0 ? null : _ref54$channelPartner;
  var _a;
  var isLoggedIn2 = !!currentUser;
  var isAdmin = !!((_a = currentUser == null ? void 0 : currentUser.adminAccount) == null ? void 0 : _a.id);
  var canAccessCorpPortal = !!(currentUser == null ? void 0 : currentUser.canAccessCorpPortal);
  var _useConsumerCartQuery = useConsumerCartQuery_default(federationUrl, fetcher),
    data = _useConsumerCartQuery.data,
    error = _useConsumerCartQuery.error,
    loading = _useConsumerCartQuery.loading;
  var orders = useMemo(function () {
    var _a2;
    return formatOrders({
      fulfillmentDetails: (_a2 = data == null ? void 0 : data.identity) == null ? void 0 : _a2.fulfillmentDetails
    }) || [];
  }, [data]);
  var trackLink = function trackLink(path, title) {
    var _a2;
    track("navlink-clicked", {
      url: window.location.href,
      misc_json: JSON.stringify({
        item_clicked: {
          link: path,
          text: title
        }
      })
    });
    (_a2 = window == null ? void 0 : window.dataLayer) == null ? void 0 : _a2.push({
      event: "track_event_header_nav",
      event_category: "Navigation",
      event_action: "Header",
      event_label: title,
      event_value: 0,
      non_interaction: false
    });
  };
  var cartProps = {
    fetcher: fetcher,
    isLoggedIn: isLoggedIn2,
    startNewOrderPath: startNewOrderPath,
    loginPath: loginPath,
    orders: orders,
    loading: loading,
    compileOrderPath: compileOrderPath,
    onLoadData: onLoadData,
    onOpen: onOpen,
    onClickOrder: onClickOrder,
    accountHierarchyPresent: Boolean(currentUser == null ? void 0 : currentUser.hasAccountHierarchy)
  };
  useEffect(function () {
    if (!loading) {
      onLoadData(orders);
    }
  }, [loading, onLoadData, orders]);
  if (error) {
    onError(error);
  }
  return /* @__PURE__ */React27.createElement(React27.Fragment, null, /* @__PURE__ */React27.createElement(DesktopExperience_default, null, /* @__PURE__ */React27.createElement(Toolbar, {
    layout: "split"
  }, /* @__PURE__ */React27.createElement(EzLayout, {
    layout: "basic",
    alignY: "center"
  }, /* @__PURE__ */React27.createElement(Logo2023_default, {
    href: isLoggedIn2 ? compilePath_default(START_NEW_ORDER_PATH) : compilePath_default(ROOT_PATH),
    trackLink: trackLink
  }), channelPartnerLogoUrl && /* @__PURE__ */React27.createElement(React27.Fragment, null, /* @__PURE__ */React27.createElement(VerticalDivider, null), /* @__PURE__ */React27.createElement(ChannelPartnerLogo, {
    "data-testid": "channel-partner-logo",
    src: channelPartnerLogoUrl
  })), landingPage && !isLoggedIn2 && /* @__PURE__ */React27.createElement(LandingDropdownMenus_default, {
    trackLink: trackLink
  }), !simplified && !landingPage && /* @__PURE__ */React27.createElement(React27.Fragment, null, isLoggedIn2 && /* @__PURE__ */React27.createElement(StyledEzLink, {
    use: "reset",
    onClick: function onClick() {
      trackLink(compilePath_default(START_NEW_ORDER_PATH), useEz429Profile ? "Home" : "Start a New Order");
      onStartNewOrderClick == null ? void 0 : onStartNewOrderClick();
    }
  }, /* @__PURE__ */React27.createElement("a", {
    href: compilePath_default(START_NEW_ORDER_PATH)
  }, useEz429Profile ? "Home" : "Start a New Order")), isLoggedIn2 && /* @__PURE__ */React27.createElement(StyledEzLink, {
    use: "reset",
    onClick: function onClick() {
      trackLink(compilePath_default(YOUR_ORDERS_PATH), useEz429Profile ? "Orders" : "Your Orders");
    }
  }, /* @__PURE__ */React27.createElement("a", {
    href: compilePath_default(YOUR_ORDERS_PATH)
  }, useEz429Profile ? "Orders" : "Your Orders")), isLoggedIn2 && /* @__PURE__ */React27.createElement(StyledEzLink, {
    use: "reset",
    onClick: function onClick() {
      trackLink(compilePath_default(SAVED_RESTAURANTS_PATH), useEz429Profile ? "Saved restaurants" : "Saved Restaurants");
    }
  }, /* @__PURE__ */React27.createElement("a", {
    href: compilePath_default(SAVED_RESTAURANTS_PATH)
  }, useEz429Profile ? "Saved restaurants" : "Saved Restaurants")))), /* @__PURE__ */React27.createElement(EzLayout, {
    layout: "basic",
    alignY: "center"
  }, !simplified && canAccessCorpPortal && /* @__PURE__ */React27.createElement(AdminLink, {
    onClick: function onClick() {
      trackLink(corpPortalHost, "Corporate Admin");
    }
  }, /* @__PURE__ */React27.createElement("a", {
    href: corpPortalHost
  }, "Corporate Admin")), /* @__PURE__ */React27.createElement(StyledEzLink, {
    href: "tel:".concat(supportPhoneNumber),
    onClick: function onClick() {
      trackLink("tel:".concat(supportPhoneNumber), supportPhoneNumber);
    }
  }, supportPhoneNumber), contactUsNavItemHandler ? /* @__PURE__ */React27.createElement(StyledEzButton2, {
    legacy: true,
    use: "tertiary",
    onClick: function onClick() {
      trackLink("#", "Contact Us Button");
      contactUsNavItemHandler();
    }
  }, "Contact Us") : /* @__PURE__ */React27.createElement(ContactUsDropdownMenu_default, {
    supportPhoneNumber: supportPhoneNumber,
    supportFaxNumber: supportFaxNumber,
    openLibertyChat: openLibertyChat,
    trackLink: trackLink
  }), !isLoggedIn2 && /* @__PURE__ */React27.createElement(StyledEzLink, {
    use: "reset",
    onClick: function onClick() {
      trackLink(loginPath, "Sign In");
    }
  }, /* @__PURE__ */React27.createElement("a", {
    href: loginPath
  }, "Sign In")), !simplified && /* @__PURE__ */React27.createElement(React27.Fragment, null, /* @__PURE__ */React27.createElement(VerticalDivider, null), isLoggedIn2 && (useEz429Profile ? /* @__PURE__ */React27.createElement(Ez429ProfileAppBarItem_default, {
    currentUser: currentUser,
    track: track,
    trackLink: trackLink,
    pointsGivenForReview: pointsGivenForReview
  }) : /* @__PURE__ */React27.createElement(ProfileAppBarItem_default, {
    currentUser: currentUser,
    track: track,
    trackLink: trackLink,
    corpPortalHost: corpPortalHost,
    pointsGivenForReview: pointsGivenForReview
  })), isLoggedIn2 && notifications && notifications.length > 0 && /* @__PURE__ */React27.createElement(DirectConnectButton_default, {
    notifications: notifications,
    trackLink: trackLink
  }), isAdmin && /* @__PURE__ */React27.createElement(StyledEzLink, {
    href: cartId ? compilePath_default(ADMIN_ORDER_PATH, {
      cartId: cartId
    }) : compilePath_default(ADMIN_PATH),
    "data-testid": "admin-nav-bar-item",
    onClick: function onClick() {
      trackLink(cartId ? compilePath_default(ADMIN_ORDER_PATH, {
        cartId: cartId
      }) : compilePath_default(ADMIN_PATH), "admin-lock-icon");
    }
  }, /* @__PURE__ */React27.createElement(StyledEzIcon3, {
    icon: faLock
  })), /* @__PURE__ */React27.createElement(ConsumerCart_default, _objectSpread(_objectSpread({}, cartProps), {}, {
    useNewCart: true,
    trackLink: trackLink
  })))))), /* @__PURE__ */React27.createElement(MobileAndTabletExperience_default, null, /* @__PURE__ */React27.createElement(MobileToolbar, {
    layout: "split"
  }, /* @__PURE__ */React27.createElement(EzLayout, {
    layout: "basic",
    alignY: "center"
  }, /* @__PURE__ */React27.createElement(MobileMenuBars_default, {
    supportPhoneNumber: supportPhoneNumber,
    supportFaxNumber: supportFaxNumber,
    landingPage: landingPage,
    track: track,
    trackLink: trackLink,
    currentUser: currentUser,
    corpPortalHost: corpPortalHost,
    useEz429Profile: useEz429Profile,
    ez429TrackExposure: ez429TrackExposure,
    pointsGivenForReview: pointsGivenForReview
  }), /* @__PURE__ */React27.createElement(Logo2023_default, {
    href: isLoggedIn2 ? compilePath_default(START_NEW_ORDER_PATH) : compilePath_default(ROOT_PATH),
    trackLink: trackLink
  })), !simplified && /* @__PURE__ */React27.createElement(EzLayout, {
    layout: "basic",
    alignY: "center"
  }, notifications && /* @__PURE__ */React27.createElement(DirectConnectButton_default, {
    notifications: notifications,
    trackLink: trackLink
  }), isAdmin && /* @__PURE__ */React27.createElement(StyledEzLink, {
    href: cartId ? compilePath_default(ADMIN_ORDER_PATH, {
      cartId: cartId
    }) : compilePath_default(ADMIN_PATH),
    "data-testid": "admin-nav-bar-item",
    onClick: function onClick() {
      trackLink(cartId ? compilePath_default(ADMIN_ORDER_PATH, {
        cartId: cartId
      }) : compilePath_default(ADMIN_PATH), "admin-lock-icon");
    }
  }, /* @__PURE__ */React27.createElement(StyledEzIcon3, {
    icon: faLock
  })), /* @__PURE__ */React27.createElement(ConsumerCart_default, _objectSpread(_objectSpread({}, cartProps), {}, {
    useNewCart: true,
    menuPageClickHandler: menuPageClickHandler,
    cartHasItems: cartHasItems,
    trackLink: trackLink
  }))))));
};
var AppBar_default = AppBar;
export { AppBar_default as AppBar, ConsumerCart_default as ConsumerCart };